//
// InstantSearch+ for Shopify - Apr. 2014
// Copyright (c) Fast Simon Inc.
// shopify-results.js

if (typeof __isp_serp_injected === 'undefined')	{
	var __isp_serp_injected = true;
	var isp_serp_load_time = Date.now();
	var isp_page_load_to_serp_load_latency = null;

	if (typeof isp_search_results_base_page_load_time != 'undefined' && isp_search_results_base_page_load_time) {
		isp_page_load_to_serp_load_latency = isp_serp_load_time - isp_search_results_base_page_load_time;
		isp_log('time to search_results_page evaluation: '+ isp_page_load_to_serp_load_latency);
	}
	if (typeof isp_script_load_to_first_search_latency == 'undefined') {
		var isp_script_load_to_first_search_latency = null;
	}


	try {
		_isp_host_prefix = localStorage.getItem('_isp_host_prefix');
		if (_isp_host_prefix.match(/^[a-z0-9-]+$/)) {
			_isp_api_prefix = localStorage.getItem('_isp_api_prefix');
			if (_isp_api_prefix && !_isp_api_prefix.match(/^[a-z0-9-]+$/)) {
				_isp_api_prefix = null;
			}
			_isp_min_on = false;
		} else {
			_isp_host_prefix = null;
			_isp_api_prefix = null;
		}
		_isp_force_version = localStorage.getItem('_isp_force_version');
	} catch (e) {}

	var ISP_AVOID_PRICE_NON_LOGIN_USERS = false;
	try { 
		ISP_AVOID_PRICE_NON_LOGIN_USERS = localStorage.getItem('isp_avoid_price_non_login_users');
		if (ISP_AVOID_PRICE_NON_LOGIN_USERS == "false"){
			ISP_AVOID_PRICE_NON_LOGIN_USERS = false;
		} else if (ISP_AVOID_PRICE_NON_LOGIN_USERS == "true"){
			ISP_AVOID_PRICE_NON_LOGIN_USERS = true
		}
	} catch (e) {}

	if (typeof __acp == 'undefined') {
		var __isp_post_load_url = "https://ping-dot-acp-magento.appspot.com/post_load";
	} else {
		var __isp_post_load_url = __acp.ACP_MAGENTO_POST_LOAD_URL_HTTPS + "/post_load";
	}

	if (typeof isp_isLocalStorageNameSupported === "undefined") {
		isp_isLocalStorageNameSupported = function() {
			var testKey = 'test', storage = window.sessionStorage;
			try {
				storage.setItem(testKey, '1');
				storage.removeItem(testKey);
				return true;
			} catch (error) {
				return false;
			}
		}
	}

	if (typeof api_db_set === "undefined") {
		api_db_set = function(key, val, cross_domain) {	// key, value
			try {
				if (isp_isLocalStorageNameSupported())	{
					return localStorage.setItem(key, val);  
				} else {
					return $jquery.cookie(key, val, { expires: 365, path: '/' });			
				}
			} catch (e) {}		
		}	
	}
	if (typeof api_db_get === "undefined") {
		api_db_get = function(key, cross_domain) {	// key
			try {
				if (isp_isLocalStorageNameSupported())	{			
					return localStorage.getItem(key);	
				} else {
					return $jquery.cookie(key);	
				}
			} catch (e) {
				return null;
			}				
		}	
	}

	if (typeof api_db_remove === "undefined") {
		api_db_remove = function(key, cross_domain) {
			return localStorage.removeItem(key);	
			// return $jquery.cookie(key, null);		
			/*	return appAPI.db.remove(key);		*/				
		}	// key
	}

	if (typeof api_db_set2 === "undefined") {
		// Localstorage only version
		api_db_set2 = function(key, val, cross_domain) {	// key, value
			try {
				return localStorage.setItem(key, val);  
			} catch (e) {
				return null;
			}		
		}	
		api_db_get2 = function(key, cross_domain) {	// key
			try {
				return localStorage.getItem(key);	
			} catch (e) {
				return null;
			}				
		}	
	}

	if (typeof _isp_post_load_cb === "undefined") {
		_isp_post_load_cb = function(load_data) {
			if (load_data.isp_token && load_data.isp_token != '')	{
				__isp_token = load_data.isp_token;
				try { api_db_set(__isp_token_KEY, load_data.isp_token);	}	catch (e)	{}
			}
			var personalization_enabled = false;
			if (typeof load_data.personalization_enabled !== 'undefined')	{
				personalization_enabled = load_data.personalization_enabled;
			}
			try { 
				localStorage.setItem('isp_personalization_enabled_saved', personalization_enabled); 
				if (localStorage.getItem('isp_force_personalization_enabled') === null) {
					localStorage.setItem('isp_personalization_enabled', personalization_enabled);
				} else {
					localStorage.setItem('isp_personalization_enabled', 
										 localStorage.getItem('isp_force_personalization_enabled'));
				}
			} catch (e) {}
			try {
				if (typeof load_data.location !== 'undefined' && load_data.location) {
					localStorage.setItem('isp_location', load_data.location);
				} else {
					localStorage.removeItem('isp_location');
				}
			} catch (e) {}
			try {
				if ( typeof load_data.ab_mode === "object" ||
					 load_data.ab_mode.constructor === Object) {
					__isp_ab_mode = load_data.ab_mode;
					api_db_set(__isp_ab_mode_KEY, JSON.stringify(__isp_ab_mode));
				}
			} catch (e) {}
			function fire_merchandising_load() {
				if (typeof _isp_fire_merchandising_load === "undefined") {
					setTimeout(fire_merchandising_load, 100);
				} else {
					_isp_fire_merchandising_load();
				}
			}
		}
	}

	function createCookie(name,value,days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
		}
		else var expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	}

	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	function eraseCookie(name) {
		createCookie(name,"",-1);
	}



	function isp_log(msg)	{
		try {
			// console.log(msg);
		} catch (e) {}
	}


	function getParameterByNameOrDefault(name, default_val) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(location.search);
			
		ret = ( results == null ? default_val : decodeURIComponent(results[1].replace(/\+/g, " ")) );
		if (results == null && name == 'q' && location.search == '' && location.pathname.indexOf('/pages/filter-/') == 0)	{
			// fallback to Shopify SEO version
			ret = location.pathname.replace('/pages/filter-search/', '');
			if(ret.substr(-1) === '/') {
				ret = ret.substr(0, ret.length - 1);
			}
			ret = decodeURIComponent(ret);
		}
		return ret;
	}

	function getParameterFromString(str, name, default_val) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(str);
		return results == null ? default_val : decodeURIComponent(results[1].replace(/\+/g, " "));
	}

	function is_RTL( term )	{
		for (var i=0;i<term.length;i++){
			if ( (term.charCodeAt(i) > 0x590) && (term.charCodeAt(i) < 0x5FF) )  {	
				return true;
			}	
		}
		return false;
	}

	var is_premium = getParameterByNameOrDefault('premium', '0');
	var isp_is_mobile_v1 = '0';

	if( /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ) {	
		isp_is_mobile_v1 = '1';	
	}
	var COLOR_FACET_REGEX = new RegExp("^\#[0-9A-F]{6}(,\#[0-9A-F]{6})*$")
	var NUM_MAX_FACETS = 8
	if (isp_is_mobile_v1 == '1')	{	NUM_MAX_FACETS = 2;	}

	if (typeof __isp_token === 'undefined') {
		var __isp_token = '';
		var __isp_token_KEY = 'isp_token_1';
		var __isp_ab_mode_KEY = 'isp_ab_mode_1';
		var __isp_ab_mode = null;
	}

	try	{
		if (!__isp_token) {
			__isp_token = api_db_get( __isp_token_KEY );
		}
		if (!__isp_token || __isp_token == '' || __isp_token === 'null') { __isp_token = ''; }
	} catch (e)	{}

	if (!__isp_ab_mode) {
		(function() {
			try {
				var mode = api_db_get(__isp_ab_mode_KEY);
				if (!mode || mode == 'null' || mode == 'undefined') {
					return;
				}
				var mode_object = JSON.parse(mode);
				if (typeof mode_object !== "object" || mode_object.constructor !== Object) {
					return;
				}
				__isp_ab_mode = mode_object;
			} catch (e) {}
		})();
	}

	if (typeof __isp_get_session === "undefined") {
		__isp_get_session = function() {
			var session_KEY = 'isp_session_1';

			var now = Math.floor(new Date() / 1000);
			try {
				var session = api_db_get(session_KEY);
				var max_idle = 1800;
				try {
					session = JSON.parse(session);
					if (now - session.last_active >= max_idle || typeof session !== "object") {
						session = {'last_active': now, 'start': now};
					} else {
						session.last_active = now;
						if (typeof session.start === "undefined") {
							session.start = now;
						}
					}
				} catch (e) {
					session = {'last_active': now, 'start': now};
				}
				api_db_set(session_KEY, JSON.stringify(session));	
				
				return session;
			} catch (e) {
				return null;
			}
		}
	}


	var resultOpenInTab      = getParameterByNameOrDefault('resultOpenInTab', 'true'); 

	try { navLang = localStorage.getItem('isp_header_lang');	}	catch (e) {}
	if (navLang == null || navLang == 'auto')	{	
		navLang = (navigator.language) ? navigator.language : navigator.userLanguage;	
		navLang = navLang.substring(0,2).toLowerCase();	
	}

	var loading_text = 'Loading results';
	var no_results_text = 'No results for';
	var no_results_suggestion_text = '<p style="padding-left: 10px;">Suggestions:</p><ul><li>Make sure all words are spelled correctly.</li><li>Try different keywords.</li><li>Try more general keywords.</li><li>Try fewer keywords.</li></ul>';
	var in_category_text  = 'in';
	var more_nav_text 	  = 'More &#187;';
	var add_to_cart_text  = 'Add to Cart';
	var SEARCH_RESULTS_FOR_TEXT = 'Search results for '
	var placeholder_text = 'Search site';
	var any_facet_text = 'Any';

	switch (navLang)	{
		case 'az':
			loading_text = 'Loading...';
			no_results_text = 'üçün nəticə tapıla bilmədi';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Müəyyən səbəblərə görə axtarışa uyğun nəticə tapıla bilmədi:</p><ul><li>Bütün sözlərin düzgün yazıldlğından əmin olun</li><li>Başqa kəlimələrlə yenidən axtarmağa çalışın</li><li>Daha çox işlədilə biləcək kəlimələrlə axtarmağa çalışın</li><li>Daha az kəlimələrlə axtarmağa çalışın</li></ul>';		
			in_category_text = 'səhifə';
			more_nav_text =  'עוד &#187;';	
			add_to_cart_text = 'SƏBƏTƏ ƏLAVƏ ET';
			SEARCH_RESULTS_FOR_TEXT = 'Axtarış nəticələri ';
			placeholder_text = 'Səhifəni axtar';
			any_facet_text = 'hər hansı';
			break;
		case 'ro':
			loading_text = 'încărcare...';
			no_results_text = 'nici un rezultat pentru';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Sugestii:</p><ul><li> Asigurați-vă că toate cuvintele sunt scrise corect</li><li>Încercați cuvinte cheie diferite</li><li>Încercați cuvinte cheie mai generale</li><li>Încercați mai puține cuvinte cheie</li></ul>';		
			in_category_text = 'în';
			more_nav_text = 'mai mult &#187;';
			add_to_cart_text = 'PUNE-L ÎN COŞ';
			SEARCH_RESULTS_FOR_TEXT = 'cauta rezultate pentru ';
			placeholder_text = 'site-ul de căutare';
			any_facet_text = 'orice';
			break;
			
		case 'he':
			any_facet_text = 'כל';
			loading_text = 'טוען תוצאות';
			no_results_text = 'אין תוצאות עבור';
			no_results_suggestion_text = '<p style="padding-left: 10px;">הצעות:</p><ul><li>ודא שכל המילים מאוייתות נכון</li><li>נסה מילות מפתח אחרות</li><li>נסה מילות מפתח כלליות יותר</li><li>נסה פחות מילות מפתח</li></ul>';		
			in_category_text = 'בדף';
			more_nav_text =  'עוד &#187;';	
			add_to_cart_text = 'הוסף לסל';
			SEARCH_RESULTS_FOR_TEXT = 'תוצאות חיפוש עבור ';
			break;
		case 'sr':
			loading_text = 'Učitavam rezultate';
			no_results_text = 'Nema rezultata za';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Takodje pokušajte:</p><ul><li>Proverite da li su sve reči ispravno unete.</li><li>Pokušajte sa drugim ključnim rečima.</li><li>Pokušajte sa opštim frazama.</li><li>Pokušajte sa manje ključnih reči.</li></ul>';		
			in_category_text = 'u sekciji';
			SEARCH_RESULTS_FOR_TEXT = 'Резултати претраге за ';
			break;	
		case 'ru':
			loading_text = 'Загружает результаты';
			no_results_text = 'Нет результатов по';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Рекомендации:</p><ul><li>Убедитесь, что все слова написаны без ошибок.</li><li>Попробуйте использовать другие ключевые слова.</li><li>Попробуйте использовать более популярные ключевые слова.</li><li>Попробуйте уменьшить количество слов в запросе.</li></ul>';		
			in_category_text = 'в';
			more_nav_text = 'более &#187;';
			add_to_cart_text = 'Добавить в корзину';
			SEARCH_RESULTS_FOR_TEXT = 'Результаты поиска для ';
			any_facet_text = 'Все';
			break;
		case 'fr':	
			loading_text = 'Chargement des résultats';
			no_results_text = 'Pas de résultats pour';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Suggestions:</p><ul><li>Vérifiez l’orthographe des termes de recherche.</li><li>Essayez d\'autres mots.</li><li>Utilisez des mots clés plus généraux.</li><li>Spécifiez un moins grand nombre de mots.</li></ul>';		
			in_category_text = 'dans';
			more_nav_text = 'plus &#187;';
			add_to_cart_text = 'Ajouter au panier';
			SEARCH_RESULTS_FOR_TEXT = 'Résultats de la recherche pour ';
			break;
		case 'de':
			loading_text = 'Ergebnisse werden geladen';
			no_results_text = 'Keine Ergebnisse für';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Vorschläge:</p><ul><li>Achten Sie darauf, dass alle Wörter richtig geschrieben sind.</li><li>Probieren Sie es mit anderen Suchbegriffen.</li><li>Probieren Sie es mit allgemeineren Suchbegriffen.</li><li>Probieren Sie es mit weniger Suchbegriffen.</li></ul>';		
			in_category_text = 'in';
			more_nav_text = 'mehr &#187;';
			add_to_cart_text = 'In den Warenkorb legen';
			SEARCH_RESULTS_FOR_TEXT = 'Suchergebnisse für ';
			break;
		case 'pt':
			loading_text = 'Carregando resultados';
			no_results_text = 'Nenhum resultado para';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Sugestões:</p><ul><li>Certifique-se de que todas as palavras estejam escritas corretamente.</li><li>Tente palavras-chave diferentes.</li><li>Tente palavras-chave mais genéricas.</li><li>Tente usar menos palavras-chave.</li></ul>';		
			in_category_text = 'em';
			more_nav_text = 'mais &#187;';
			add_to_cart_text = 'Adicionar ao carrinho';
			SEARCH_RESULTS_FOR_TEXT = 'Resultados da pesquisa para ';
			break;
		case 'it':
			loading_text = 'Caricamento dei risultati';
			no_results_text = 'Nessun risultato per';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Suggerimenti:</p><ul><li>Assicurarsi che tutte le parole siano state digitate correttamente.</li><li>Provare con parole chiave diverse.</li><li>Provare con parole chiave più generiche.</li><li>Provare con un numero minore di parole chiave.</li></ul>';		
			in_category_text = 'in';
			more_nav_text = 'di più &#187;';
			add_to_cart_text = 'Aggiungi al carrello';
			SEARCH_RESULTS_FOR_TEXT = 'Risultati della ricerca per ';
			break;
		case 'es':
			loading_text = 'Cargando resultados';
			no_results_text = 'Ningún resultado para';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Sugerencias:</p><ul><li>Comprueba que todas las palabras están escritas correctamente.</li><li>Intenta usar otras palabras.</li><li>Intenta usar palabras más generales.</li><li>Intente usar menos palabras.</li></ul>';		
			in_category_text = 'en';
			more_nav_text = 'más &#187;';
			add_to_cart_text = 'Añadir a la cesta';
			SEARCH_RESULTS_FOR_TEXT = 'Resultados de la búsqueda ';
			break;	
		case 'da':	
			loading_text = 'Henter resultater';
			no_results_text = 'Ingen resultater for';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Forslag:</p><ul><li>Sørg for, at alle ord er stavet korrekt.</li><li>Prøv forskellige søgeord.</li><li>Prøv mere generelle søgeord.</li><li>Prøv færre søgeord.</li></ul>';		
			in_category_text = 'i';
			add_to_cart_text = 'Læg i kurv';
			SEARCH_RESULTS_FOR_TEXT = 'Søgeresultater for ';
			break;
		case 'nl':
			loading_text = 'resultaat wordt geladen';
			no_results_text = 'Geen resultaten voor';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Suggesties:</p><ul><li>Zorg ervoor dat alle woorden goed gespeld zijn.</li><li>Probeer andere zoektermen.</li><li>Maak de zoektermen algemener.</li><li>Gebruik minder zoekwoorden.</li></ul>';		
			in_category_text = 'in';
			add_to_cart_text = 'Bestellen';
			SEARCH_RESULTS_FOR_TEXT = 'Zoek resultaten voor ';
			break;
		case 'fi':
			loading_text = 'Lataa tulokset';
			no_results_text = 'Ei tuloksia';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Ehdotuksia:</p><ul><li>Varmista, että kaikki sanat on kirjoitettu oikein.</li><li>Kokeile eri hakusanoja.</li><li>Kokeile yleisempiä hakusanoja.</li><li>Vähennä hakusanoja.</li></ul>';		
			in_category_text = 'sisään';
			add_to_cart_text = 'Lisää koriin';
			SEARCH_RESULTS_FOR_TEXT = 'Hae tulokset ';
			break;
		case 'no':
			loading_text = 'Laster treff';
			no_results_text = 'Ingen resultater for';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Forslag:</p><ul><li>Sjekk at alle ordene er stavet rett.</li><li>Prøv andre søkeord.</li><li>Prøv mer generelle søkeord.</li><li>Prøv færre søkeord.</li></ul>';	
			in_category_text = 'i';
			add_to_cart_text = 'Legg til kurv';
			SEARCH_RESULTS_FOR_TEXT = 'Søkeresultater for ';
			break;
		case 'se':
			loading_text = 'Laddar';
			no_results_text = 'Inga resultat för';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Förslag:</p><ul><li>Kontrollera att alla ord är rättstavade.</li><li>Försök med andra sökord.</li><li>Försök med mer allmänna sökord.</li><li>Försök med färre sökord.</li></ul>';	
			in_category_text = 'i';		
			more_nav_text = 'mer &#187;';
			add_to_cart_text = 'Añadir a la cesta';
			SEARCH_RESULTS_FOR_TEXT = 'Sökresultat för ';
			break;
		case 'pl':
			loading_text = 'Laduje wyniki';
			no_results_text = 'Brak wyników dla';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Podpowiedzi:</p><ul><li>Sprawdz, czy wszystkie slowa zostaly poprawnie napisane.</li><li>Spróbuj uzyc innych slów kluczowych.</li><li>Spróbuj uzyc bardziej ogólnych slów kluczowych.</li><li>Spróbuj uzyc mniejszej liczby slów kluczowych.</li></ul>';		
			in_category_text = 'na';
			add_to_cart_text = 'Dodaj do koszyka';
			SEARCH_RESULTS_FOR_TEXT = 'Wyniki wyszukiwania dla ';
			break;
		case 'tr':
			loading_text = 'yükleme sonuçlari';
			no_results_text = 'Için sonuç yok';
			no_results_suggestion_text = '<p style="padding-left: 10px;">Öneriler:</p><ul><li>Tüm kelimeleri dogru yazdiginizdan emin olun.</li><li>Baska anahtar kelimeleri deneyin.</li><li>Daha genel anahtar kelimeleri deneyin.</li><li>Daha az anahtar kelime deneyin.</li></ul>';		
			in_category_text = 'içinde';
			more_nav_text = 'daha fazla &#187;';
			add_to_cart_text = 'Sepete ekle';		
			SEARCH_RESULTS_FOR_TEXT = 'Için arama sonuçları ';
			break;		
		default:		
			break;	
	}

	function getRelatedSearchesMessage(){
		var default_phrase = 'Related Searches: ';
		try {
			switch (navLang){
				case 'en':
					return default_phrase;
				
				case 'es':
					return 'Búsquedas Relacionadas: ';
				case 'pt':
					return 'Buscas Relacionadas: ';
				
				case 'fr':
					return 'Recherches Associées: ';
				case 'de':
					return 'Ähnliche Suchen: ';
				case 'nl':
					return 'Verwante Zoekopdrachten: ';  
				case 'it':
					return 'Ricerche Correlate: ';
				case 'he':
					return 'חיפושים קשורים: ';
				
				case 'tr':
					return 'İlgili Aramalar: ';
				case 'da':
					return 'Relaterede søgninger: ';
				case 'ja':
					return '関連キーワード： ';
				
				case 'fi':
					return 'Valokuvat: ';
				case 'hu':
					return 'Kapcsolódó Keresések: ';
				
				case 'se':
					return 'Relaterade sökningar: ';
					
				default:
					return default_phrase;
			}   
		} catch (e) {
			return default_phrase; // default -> english
		}   
		return default_phrase;
	}


	function getDidYouMeanLanguageMessage(){
		var default_phrase = 'Did you mean: ';
		try {
			switch (navLang){
				case 'en':
					return default_phrase;
				case 'es':
					return 'Quizás quiso decir: ';
				case 'az':
					return 'Bunu demək istədiniz: ';
				case 'pt':
					return 'Você quis dizer: ';
				case 'ru':
					return 'Вы имели в виду: ';
				case 'fr':
					return 'Vouliez-vous dire: ';
				case 'de':
					return 'Meintest Du: ';
				case 'nl':
					return 'Bedoelde u: ';  
				case 'it':
					return 'Forse cercavi: ';
				case 'he':
					return 'האם התכוונת: ';
				case 'pl':
					return 'Czy chodziło Ci o: ';
				case 'tr':
					return 'Demek istediğin: ';
				case 'da':
					return 'Mente du: ';
				case 'ja':
					return 'もしかして: ';
				case 'zh':
					return '你的意思: ';
				case 'el':
					return 'Μήπως εννοείτε: ';
				case 'ro':
					return 'Ați vrut să spuneți: '; 
				case 'bg':
					return 'Може би имахте предвид: ';
				case 'cs':
					return 'Měli jste na mysli: ';
				case 'fi':
					return 'Tarkoititko: ';
				case 'hu':
					return 'Gondolt: ';
				case 'id':
					return 'Apakah maksud Anda: ';
				case 'no':
					return 'Mente du: ';
				case 'se':
					return 'Menade du: ';
					
				default:
					return default_phrase;
			}	
		} catch (e) {
			return default_phrase; // default -> english
		}	
		return default_phrase;
	}

	function getNoSearchResultsMessage(original_query, fixed_query){
		var default_phrase = 'No results for <b>"' + original_query + '"</b>, ';
		try {
			switch (navLang){
				case 'en':
					return default_phrase;
				case 'es':
					return 'No hay resultados para <b>"' + original_query + '"</b>, ';
				case 'az':
					return 'Müəyyən səbəblərə görə nəticə tapıla bilmədi <b>"' + original_query + '"</b>, '; 
				case 'pt':
					return 'Nenhum resultado para <b>"' + original_query + '"</b>, ';
				case 'ru':
					return 'Нет результатов для <b>"' + original_query + '"</b>, ';
				case 'fr':
					return 'Pas de résultats pour <b>"' + original_query + '"</b>, ';
				case 'nl':
					return 'Geen resultaten voor <b>"' + original_query + '"</b>, ';
				case 'de':
					return 'Keine Ergebnisse für <b>"' + original_query + '"</b>, ';
				case 'it':
					return 'Nessun risultato per <b>"' + original_query + '"</b>, ';
				case 'he': 
					return 'אין תוצאות עבור <b>"' + original_query + '"</b>, ';
				case 'pl':
					return 'Brak wyników dla <b>"' + original_query + '"</b>, ';
				case 'tr':
					return 'Için sonuç <b>"' + original_query + '"</b>, ';
				case 'da':
					return 'Ingen resultater for <b>"' + original_query + '"</b>, ';
				case 'ja':
					return 'のための結果はありません <b>"' + original_query + '"</b>, ';
				case 'zh':
					return '没有结果 <b>"' + original_query + '"</b>, ';
				case 'el':
					return 'Δεν υπάρχουν αποτελέσματα για την <b>"' + original_query + '"</b>, ';
				case 'ro':
					return 'Niciun rezultat pentru <b>"' + original_query + '"</b>, '; 
				case 'bg':
					return 'Няма резултати за <b>"' + original_query + '"</b>, ';
				case 'cs':
					return 'Žádné výsledky pro <b>"' + original_query + '"</b>, ';
				case 'fi':
					return 'Ei tuloksia <b>"' + original_query + '"</b>, ';
				case 'hu':
					return 'Nincs eredmény a <b>"' + original_query + '"</b>, ';
				case 'id':
					return 'Tidak ada hasil untuk <b>"' + original_query + '"</b>, ';
				case 'no':
					return 'Ingen resultater for <b>"' + original_query + '"</b>, ';
				case 'se':
					return 'Inga resultat för <b>"' + original_query + '"</b>, ';
					
				default:
					return default_phrase;
			}		
		} catch (e) {
			return default_phrase; // default -> english
		}	
		return default_phrase;
	}

	function getSearchResultsForMessage(results_for_query, total_search_results){
		var default_phrase = 'Showing ' + total_search_results + ' results for <b>"' + results_for_query + '"</b>';
		try {
			switch (navLang){
				case 'en':
					return default_phrase;
				case 'az':
					return 'üçün tapılan ' + total_search_results + ' nəticə <b>"' + results_for_query + '"</b>';
				case 'es':
					return 'Mostrando los ' + total_search_results + ' resultados para <b>"' + results_for_query + '"</b>';
				case 'pt':
					return 'Mostrando ' + total_search_results + ' resultados para <b>"' + results_for_query + '"</b>';
				case 'ru':
					return 'Показаны ' + total_search_results + ' результаты для <b>"' + results_for_query + '"</b>';
				case 'fr':
					return 'Affichage des ' + total_search_results + ' résultats pour <b>"' + results_for_query + '"</b>';
				case 'nl':
					return 'Resultaten ' + total_search_results + ' voor <b>"' + results_for_query + '"</b>';
				case 'de':
					return 'Zeigt ' + total_search_results + ' Ergebnisse für <b>"' + results_for_query + '"</b>';
				case 'it':
					return 'Mostrando ' + total_search_results + ' risultati per <b>"' + results_for_query + '"</b>';
				case 'he': 
					return 'מראה' + total_search_results + '  תוצאות עבור <b>"' + results_for_query + '"</b>';
				case 'pl':
					return 'Pokazano ' + total_search_results + ' wyników <b>"' + results_for_query + '"</b>';
				case 'tr':
					return 'Gösterilen ' + total_search_results + ' sonuçlar <b>"' + results_for_query + '"</b>';
				case 'da':
					return 'Viser ' + total_search_results + ' resultater for <b>"' + results_for_query + '"</b>';
				case 'ja':
					return '表示 ' + total_search_results + ' の結果 <b>"' + results_for_query + '"</b>';
				case 'zh':
					return '显示' + total_search_results + '结果 <b>"' + results_for_query + '"</b>';
				case 'el':
					return 'Εμφανίζονται ' + total_search_results + ' αποτελέσματα για <b>"' + results_for_query + '"</b>';
				case 'ro':
					return 'Sunt arătate ' + total_search_results + ' rezultatele de <b>"' + results_for_query + '"</b>'; 
				case 'bg':
					return 'Показване ' + total_search_results + ' резултати за <b>"' + results_for_query + '"</b>';
				case 'cs':
					return 'Zobrazeny ' + total_search_results + ' výsledky pro <b>"' + results_for_query + '"</b>';
				case 'fi':
					return 'Näytetään ' + total_search_results + ' tulosta <b>"' + results_for_query + '"</b>';
				case 'hu':
					return 'A következő ' + total_search_results + ' eredmények <b>"' + results_for_query + '"</b>';
				case 'id':
					return 'Menampilkan ' + total_search_results + ' hasil untuk <b>"' + results_for_query + '"</b>';
				case 'no':
					return 'Viser ' + total_search_results + ' resultater for <b>"' + results_for_query + '"</b>';
				case 'se':
					return 'Visar ' + total_search_results + ' resultat för <b>"' + results_for_query + '"</b>';
					
				default:
					return default_phrase;
			}       
		} catch (e) {
			return default_phrase; // default -> english
		}   
		return default_phrase;
	}

	function injectCSS(styles) {
		var css = document.createElement('style');
		css.type = 'text/css';
		if (css.styleSheet) {	css.styleSheet.cssText = styles;	}
		else {	css.appendChild(document.createTextNode(styles));	}
		document.getElementsByTagName("head")[0].appendChild(css);
	}

	function mobile_scroll_top_left()	{
		var box_offset_top = $jquery_isp('#acp_magento_search_id_main_page').offset().top;
		$jquery_isp(window).scrollTop( box_offset_top - 10 );
		$jquery_isp(window).scrollLeft( 10 );
	}

	function hideKeyboard(element) {
		var field = document.createElement('input');
		field.setAttribute('type', 'text');
		field.setAttribute('style', 'border:0;outline:none;');
		document.body.appendChild(field);

		mobile_scroll_top_left();
				
		setTimeout(function() {
			field.focus();
			mobile_scroll_top_left();
				
			setTimeout(function() {
				field.setAttribute('style', 'display:none;');
				
				mobile_scroll_top_left();			
			}, 10);
		}, 10);

		return;
		
		// EARLIER APPROACH...
		
		element.setAttribute('readonly', 'readonly'); // Force keyboard to hide on input field.
		// element.setAttribute('disabled', 'true'); // Force keyboard to hide on textarea field.
		setTimeout(function() {
			element.blur();  //actually close the keyboard
			// Remove readonly attribute after keyboard is hidden.
			element.removeAttribute('readonly');
			// element.removeAttribute('disabled');
		}, 111);
	}

	function js_trim(str)	{
		return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	}


	function getJSvars(script_name, var_name, if_empty) {
		var script_elements = document.getElementsByTagName('script');
		if(if_empty == null) {	var if_empty ='';	}

		for (a = 0; a < script_elements.length; a++) {
			var source_string = script_elements[a].src;
			if(source_string.indexOf(script_name)>=0) {		
			   var_name = var_name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
			   var regex_string = new RegExp("[\\?&]"+var_name+"=([^&#]*)");
			   var parsed_vars = regex_string.exec(source_string);
			   if (parsed_vars == null) { return if_empty; }
			   else { return parsed_vars[1]; }
			  }
		   }
		return if_empty;
	}	

	var FACETS_DATA = [];
	var FACETS_ORDERED_SELECTIONS = [];

	var global_last_sort_by_value = '';

	function clear_facets()	{
		FACETS_DATA = [];
		FACETS_ORDERED_SELECTIONS = [];
		for (var f = 1; f <= NUM_MAX_FACETS; f++) {	// making all the filters non visible for subsequent queries
			if (document.getElementById('facet_drop_container_' + f))	{
				document.getElementById('facet_drop_container_' + f).style.display = 'none';
			}
		}
	}

	function api_do_full_text_search()	{
		// Called from the html modal search button
		do_full_text_search(document.getElementById('acp_magento_search_id_main_page').value, 1 , 13, false);
	}

	try {
		var isp_version = localStorage.getItem('ISP_VERSION');	
		var store_id    = localStorage.getItem('ISP_STORE_ID');	
		var isp_uuid    = localStorage.getItem('ISP_UUID');
	} catch(e) {} 
		
	var custom_css_load = null;
	try { custom_css_load = localStorage.getItem('isp_custom_css_' + isp_uuid + store_id);	}	catch (e) {}
	if (custom_css_load && custom_css_load != '')	{
		injectCSS(custom_css_load);
	}

	function isp_encodeQueryData(obj) {
		var str = [];
		for (var p in obj) {
			if (obj.hasOwnProperty(p)) {
				str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
			}
		}
		return str.join("&");
	}

	function submit_search_query(search_term, page, all_results, facets_required, retry)	{
		// Fallback for Safari Private mode
		if (isp_version == null && typeof __acp != "undefined"               && __acp.CLIENT_VER)			    {	isp_version = __acp.CLIENT_VER; }
		if (store_id    == null && typeof acp_magento_options != "undefined" && acp_magento_options.store_id)	{	store_id = acp_magento_options.store_id;	}
		if (isp_uuid    == null && typeof acp_magento_options != "undefined" && acp_magento_options.UUID)		{	isp_uuid = acp_magento_options.UUID;	}

		if ( typeof __isp_serp_uuid 	!= "undefined" )	{	isp_uuid = __isp_serp_uuid;		}
		if ( typeof __isp_serp_store_id != "undefined" )	{	store_id = __isp_serp_store_id;	}
			
		if (store_id==null || isp_uuid==null)	{
			if (retry < 200)	{
				setTimeout(function()	{ submit_search_query(search_term, page, all_results, facets_required, retry+1) }, 50);
			}	else	{
				try	{	console.log('could not request...')	} catch(e)	{}
			}
		}	else	{
			var s = document.createElement('script');
			s.type = 'text/javascript';		
			var __endpoint = 'https://acp-magento.appspot.com';
			var search_version = isp_version;
			try {
				var ls = localStorage.getItem('ISP_ENDPOINT_WEBAPI');
				if (ls != null)	{	__endpoint = ls; }
				if (_isp_host_prefix) {
					var prefix = _isp_api_prefix || _isp_host_prefix;
                    __endpoint  = prefix == 'localhost' ? 'https://localhost' :
														  'https://' + prefix + '-dot-acp-magento.appspot.com';
					if (_isp_force_version) {
						search_version = _isp_force_version;
					} else {
						search_version += "." + ((new Date).getTime()/1000).toString();
					}
				}
			} catch (e)	{}
			var request_data = {}; 
			var s_url = __endpoint + '/s?';
			request_data['q'] = search_term;
			request_data['v'] = search_version;
			request_data['store_id'] = store_id;
			request_data['UUID'] = isp_uuid;
			request_data['p'] = page;
			request_data['mobile'] = isp_is_mobile_v1;
			request_data['dym'] = 1; 
			
			if (all_results)	{ facets_required='1'; }
			request_data['facets_required'] = facets_required;
			if (__isp_ab_mode && typeof __isp_ab_mode.serp !== 'undefined') {
				request_data['ab_mode'] = __isp_ab_mode.serp;
			}
			
			try {
				var personalization_enabled = localStorage.getItem('isp_personalization_enabled');
				var products_viewed = localStorage.getItem('ISP_PRODUCTS_VIEWED');
			} catch (e)	{
				var personalization_enabled = false;
			}
			if (personalization_enabled == "false"){
				personalization_enabled = false;
			}
			
			if (personalization_enabled && __isp_token && 
					products_viewed && products_viewed.split(',').length >= 3) {
				request_data['st'] = __isp_token;
			}
			var location = null;
			try {
				location = localStorage.getItem('isp_location');
			} catch (e) {}
			if (location) {
				request_data['location'] = location;
			}
			
			try {
				var cdn_cache_key = localStorage.getItem('__isp_cdn_cache_key_1');
				if (cdn_cache_key && localStorage.getItem('__isp_cdn_cache_key_expiration') >= Date.now()) {
                    request_data['cdn_cache_key'] = cdn_cache_key;
                }
			} catch (e)	{}
			
			isp_serp_start_time = null;
			if (facets_required < 2) {
				isp_serp_start_time = Date.now();	
				request_data['callback'] = 'isp_srch_res';
			} else {
				request_data['callback'] = 'isp_facets_res';
			}
			
			request_data['related_search'] = 1;	// only requests with this flag should append #related_search# + the related searches 
			
			if (all_results) {	
				var page = parseInt(page,10);
				try {
					for (var p=1;p<(page + 1);p++){
						var prev_data = sessionStorage.getItem(isp_get_callback_cache_key(p));
						prev_data = JSON.parse( prev_data );
						if (prev_data.term != search_term)	{ throw "err"; }
						isp_srch_res(prev_data);
					}
					submit_search_query(search_term, 1, false, true, retry); // let's get the facets only
					return;
				} catch (e){
					request_data['all'] = 1;
					if (page > 10) { 
						request_data['p'] = 10; 
					}
				}
			}
			var narrow = get_narrow_param();
			if (narrow != '') {
				request_data['narrow'] = narrow;
			}
			if (global_last_sort_by_value != '' && typeof global_last_sort_by_value !== 'undefined') {
				request_data['sort_by'] = global_last_sort_by_value;
			}
			s_url += isp_encodeQueryData(request_data);
			s.src = s_url;				
			var x = document.getElementsByTagName('script')[0];
			x.parentNode.insertBefore(s, x);

			if (isp_first_full_text_search_time == null) {
				isp_first_full_text_search_time = Date.now();
				if (isp_script_load_to_first_search_latency == null) {
					isp_script_load_to_first_search_latency = isp_first_full_text_search_time - isp_serp_load_time;
					isp_log('time to first search: ' + isp_script_load_to_first_search_latency);
				}
			}
		}
	}

	var isp_serp_start_time = null;
	var isp_first_full_text_search_time = null;

	var latest_full_text_search;	// Global variable to keep the latest search term so we can switch between list and grid modes		
	function do_full_text_search( search_term, page, keycode, onload )	{
		try	{
			var title = SEARCH_RESULTS_FOR_TEXT + search_term;		
			document.title = title;	
			setTimeout(function(){document.title = title}, 111);		
			$jquery_isp('head title, main div.grid h1, h1.page-header').text( title );
			title += ' | ' + location.host + ' | Page ' + Math.abs(page);
			$jquery_isp('head meta[name="description"]').attr('content', search_term + ' on ' + location.host + ' | Page ' + Math.abs(page_number));		
		} catch (e) {}
		
		search_term = $jquery_isp.trim( search_term );
		if (search_term == '') {
			isp_srch_res({'term' : ''});
			return;
		}
		var search_term = search_term.toLowerCase();
		
		if (CURRENT_SEARCH_TERM != null && search_term != CURRENT_SEARCH_TERM.toLowerCase())    {
			global_last_sort_by_value = '';
			clear_facets();
		}
			
		var cache_key  = get_isp_response_cache_key( search_term, page, get_narrow_param(), global_last_sort_by_value );
		latest_full_text_search = search_term;
		
		// Show progress gif
		var loading_text = '';	
		document.getElementById('search_res_progress').style.display = 'inline-block';
		var isp_more_hyperlink = document.getElementById('isp_more_hyperlink');
		if (isp_more_hyperlink != null)	{	isp_more_hyperlink.style.display = 'none';	}

		setTimeout(function(){ 
						document.getElementById('search_res_progress').style.display = 'none'; 
						var isp_more_hyperlink = document.getElementById('isp_more_hyperlink');
						if (isp_more_hyperlink != null)	{	isp_more_hyperlink.style.display = 'inline-block';	}
				   }, 2222);	// hide the progress gif anyways after 2seconds
		
		
		if ( cache_key in isp_response_cache )	{
			setTimeout(function() { isp_srch_res( isp_response_cache[ cache_key ] ); }, 5);
		}	else	{		
			if (page==1)	{		
				document.getElementById('search_res_container').style.display = 'none';		// Hide results...
			}		
			var	all_results = false;
			var facets_required = 1;
			if (page < 0) {
				page = -page;
				all_results = true;
			} else if (page > 1) {
				facets_required = 0;
			}
			if (onload && page > 1)	{	all_results = true;	}
			submit_search_query( search_term, page, all_results, facets_required, 1 );		
		}
		
		var stateString = 'q=' + encodeURIComponent(search_term) + '&p=' + encodeURIComponent(page);
		var narrow = get_narrow_param();
		if (narrow != '') {
			stateString += '&narrow=' + encodeURIComponent(narrow);
		}
		if (global_last_sort_by_value != '' && typeof global_last_sort_by_value !== 'undefined'){
			stateString += '&sort_by=' + global_last_sort_by_value;
		}
		
		try {
			if (typeof History !== "undefined" && typeof History.pushState === "function" ) {
				var history_obj = History;
			} else {
				var history_obj = history;
			}
					
			internalHistoryChange = true;
			if (lastHistoryState == null) {			
				history_obj.replaceState({state:stateString}, null, '/pages/search-results?' + stateString);
			} else {
				history_obj.pushState({state:stateString}, null, '/pages/filter-search?' + stateString);
			}
			lastHistoryState = JSON.stringify(stateString);
			internalHistoryChange = false;
		} catch (e) {}
		
		if (isp_is_mobile_v1 == '1' && false)	{		
			hideKeyboard( document.getElementById('acp_magento_search_id_main_page') );	
			
		}	else	{
			if (onload)	{
				var obj = document.getElementById('acp_magento_search_id_main_page');
				// obj.focus();
				obj.value = obj.value;
			}
		}
	}


	function isp_change_page( page )	{
		// Show me more hyperlink
		document.getElementById('next_pager_').style.display = 'none';
		do_full_text_search( latest_full_text_search, page, 0, false );
		return false;
	}

	var lastHistoryState = null;
	var internalHistoryChange = false;

	function check_state_change() {
		// Note: We are using History.getState() instead of event.state
		var State = History.getState();
		if ( !internalHistoryChange && State && State.data.state !== undefined && 
			(JSON.stringify(State.data.state) != lastHistoryState) )	{
			isp_log("acting on state change");
			internalHistoryChange = true;
			handle_state_change(State);
			internalHistoryChange = false;
		}
	}

	function handle_state_change(State) {
	//	sessionStorage.setItem('isp_avoid_onload', true);
		var search_params = State.data.state.split('&');
		var search_term = '';
		var page = 1;
		var narrow = '';
		global_last_sort_by_value = '';
		for (var i = 0; i < search_params.length; i++) {
			var key_value = search_params[i].split('=');
			if (key_value[0] == 'q') {
				search_term = decodeURIComponent(key_value[1]);
			} else if (key_value[0] == 'p') {
				page = parseInt(decodeURIComponent(key_value[1]));
			} else if (key_value[0] == 'narrow') {
				narrow = decodeURIComponent(key_value[1]);
			} else if (key_value[0] == 'sort_by') {
				global_last_sort_by_value = decodeURIComponent(key_value[1]);
			}
		}
		
		set_facets_from_narrow_string(narrow);
		set_searchbox_query(search_term);
		do_full_text_search(search_term, -page, 0, false);
	}

	function set_searchbox_query(search_term)	{
		document.getElementById('acp_magento_search_id_main_page').value = search_term;  
		try {		
			var boxes = document.getElementsByTagName('input');
			for (var i=0;i<boxes.length;i++)	{
				var t = boxes[i].getAttribute('type').toLowerCase();
				if (t != 'text' && t!='search'){	continue;	}
				
				if (boxes[i].outerHTML.indexOf('search')>=0)	{
					try	{
						if (boxes[i].parentNode.offsetTop < 0)	{	continue;	}
					} catch (e)	{}
					
					boxes[i].setAttribute('value', search_term);
				}	
			}
		} catch (e)	{}
	}

	try {
		// Bind to StateChange Event
		History.Adapter.bind(window,'statechange',check_state_change);
		// Bind to PopState Event
		History.Adapter.bind(window,'popstate',check_state_change);
	} catch (e) {}

	function stripHTML(dirtyString) {
	  var container = document.createElement('div');
	  var text = document.createTextNode(dirtyString);
	  container.appendChild(text);
	  return container.innerHTML; // innerHTML will be a xss safe string
	}

	var query_string  = getParameterByNameOrDefault('q', '').replace('title:', '');
	query_string = stripHTML(query_string);
	var narrow_string = getParameterByNameOrDefault('narrow', '');
	var sorting_string = getParameterByNameOrDefault('sort_by', '');
	//submit_search_query( query_string, 1 ); // to prepare the server response even if we're not ready yet

	var ISP_RESULTS_PAGE_HIDE_SEARCH_BOX = null;
	function isp_onload(){	
		try{
			if (ISP_RESULTS_PAGE_HIDE_SEARCH_BOX == null){
				ISP_RESULTS_PAGE_HIDE_SEARCH_BOX = localStorage.getItem('isp_results_page_hide_search_box');
				if (typeof ISP_RESULTS_PAGE_HIDE_SEARCH_BOX != 'undefined' && (ISP_RESULTS_PAGE_HIDE_SEARCH_BOX == "true" || 
						ISP_RESULTS_PAGE_HIDE_SEARCH_BOX == true)){
					ISP_RESULTS_PAGE_HIDE_SEARCH_BOX = true;
					document.getElementById('acp_magento_search_id_main_page').style.display = 'none';
				} else {
					ISP_RESULTS_PAGE_HIDE_SEARCH_BOX = false;
				}
			}
		} catch (e){}

		try {		
			document.getElementById('acp_magento_search_id_main_page').setAttribute("placeholder", placeholder_text);
			document.getElementById('isp_icon_id').setAttribute("title", placeholder_text);

			if (is_RTL(placeholder_text))	{
				var rtl_css = "#grey, #acp_magento_search_id_main_page {text-align:right;} .acp_modal_body { direction: rtl;}";
				injectCSS( rtl_css );
			}

		} catch (e) {}

		try {
			// old htmls are missing these elements
			document.getElementById('search_res_sorting_title').innerHTML = sort_by_title_text;
			document.getElementById('sort_by_best_match_id').innerHTML = sort_match_text;
			document.getElementById('sort_by_price_low_to_high_id').innerHTML = sort_price_low_to_high_text;
			document.getElementById('sort_by_price_high_to_low_id').innerHTML = sort_price_high_to_low_text;
		} catch (e) {}
		
		document.getElementById('isp_refine_title_id').innerHTML = refine_by_text;
		document.getElementById('isp_mode_grid').style.display = 'inline'; 
		document.getElementById('isp_mode_list').style.display = 'inline'; 		
		if (isp_is_mobile_v1 == '1') { 		
			document.getElementById('isp_refine_title_id').style.display = 'none'; 
		}	else	{
			document.getElementById('isp_refine_title_id').style.display = ''; 
		}
		isp_highlight_mode();	// to be called on load

			global_last_sort_by_value = sorting_string;
			
			try {
				do_full_text_search( query_string, parseInt(getParameterByNameOrDefault('p', '1')), 13, true );   // fired upon first load
			}
			catch (e) {
				_isp_timeout_was_needed = true;
				window.setTimeout(function() {
					do_full_text_search( query_string, parseInt(getParameterByNameOrDefault('p', '1')), 13, true );   // fired upon first load
				}, 50);
			}
	//		var avoid_onload_search = sessionStorage.getItem('isp_avoid_onload');
	//
	//		if (!avoid_onload_search) {
	//			do_full_text_search( query_string, 1, 13, true );	// fired upon first load
	//		}
	//		sessionStorage.removeItem('isp_avoid_onload');		

		
		injectCSS( "ul.ui-autocomplete {z-index: 99999 !important;}" );	// set the z-index to more conservative per our dropdown so it won't hide the top site menu
		setTimeout( function() { 
			try { $jquery(__acp.input_id_0).autocomplete("close");  } catch (e) {}
			} , 111 );	 // close the dropdown upon load
		setTimeout( function() { 
			try { $jquery(__acp.input_id_1).autocomplete("close");  } catch (e) {}
			} , 111 );	 // close the dropdown upon load
	};

	window.onunload=function(){
		if (lastHistoryState) {
			var search_params = JSON.parse(lastHistoryState).split('&');
			var search_term = '';
			var page = 1;
			var narrow = '';
			var sort_by = '';
			for (var i = 0; i < search_params.length; i++) {
				var key_value = search_params[i].split('=');
				if (key_value[0] == 'q') {
					search_term = decodeURIComponent(key_value[1]);
				} else if (key_value[0] == 'p') {
					page = parseInt(decodeURIComponent(key_value[1]));
				} else if (key_value[0] == 'narrow') {
					narrow = decodeURIComponent(key_value[1]);
				} else if (key_value[0] == 'sort_by') {
					sort_by = decodeURIComponent(key_value[1]);
				}
			}
			sessionStorage.setItem(get_isp_response_cache_key(search_term, page, narrow, sort_by), currentYPosition());
		}
	}

	var isp_results_page_disable_add_to_cart = false;
	try { 
		isp_results_page_disable_add_to_cart = localStorage.getItem('isp_results_page_disable_add_to_cart');
		if (isp_results_page_disable_add_to_cart == null || isp_results_page_disable_add_to_cart == "false")	{	
			isp_results_page_disable_add_to_cart = false;
		}	else	{
			isp_results_page_disable_add_to_cart = true;
		}
	}	catch (e) {}	//	 to be used by the shopify full text

	var isp_results_page_enable_sorting = 0;
	try { 
		isp_results_page_enable_sorting = localStorage.getItem('isp_results_page_enable_sorting');
		if (isp_results_page_enable_sorting == null || isp_results_page_enable_sorting == "0" || isp_results_page_enable_sorting == "false" ||
				isp_results_page_enable_sorting == 0 || isp_results_page_enable_sorting == false || typeof isp_results_page_enable_sorting === 'undefined'){ 
			isp_results_page_enable_sorting = 0;
		}   else    {
			isp_results_page_enable_sorting = 1;
		}
	}   catch (e) {}    //   to be used by the shopify full text

		
	function after_inputbox_load()	{	
		set_searchbox_query(query_string);
		// Minimum font-size of 14px
		var inputbox = document.getElementById('acp_magento_search_id_main_page');
		var font_size = getStyle(inputbox, 'font-size');
		if (font_size.indexOf('px')>0 && parseInt( font_size.replace('px',''), 10) < 14)	{
			inputbox.style.fontSize = '14px';
		}
		
		if (Shopify && Shopify.theme && Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('masonry')==-1)	{
			$jquery_isp('#isp_container').parent().parent().css('width', '100%');	
		}
		if (Shopify && Shopify.theme && Shopify.theme.name && Shopify.theme.name.toLowerCase().indexOf('clean')==0)	{
			$jquery_isp('#isp_container').parent().parent().parent().css('width', '100%');	
		}
		
		try {
			var tagline = localStorage.getItem('isp_display_tagline');		
			if (tagline && tagline == "true" && isp_is_mobile_v1 == '0')	{
				$jquery_isp('.isp_watermark').css('display', 'inline');
			}		
		} catch (e) {}
		

		
		document.getElementById('acp_magento_search_id_main_page').onkeyup= function(e){	//**	onkeypress
			if (!e) e = window.event;
			var keyCode = e.keyCode || e.which;
			if (keyCode == '13') {
				var search_term = document.getElementById('acp_magento_search_id_main_page').value;
				do_full_text_search( search_term, 1, keyCode, false );

				try {
					setTimeout( function() { $jquery(__acp.input_id_0).autocomplete("close"); }, 111 );
					setTimeout( function() { $jquery(__acp.input_id_1).autocomplete("close"); }, 111 );
					setTimeout( function() { $jquery('#acp_magento_search_id_main_page').autocomplete("close"); }, 111 );
										
					e.preventDefault();
					e.stopImmediatePropagation();        
				} catch (e) {}
				
				if	(navigator.userAgent.match(/iPad/i) != null || navigator.userAgent.match(/iPhone/i) != null)	{
					//	hide iPad keyboard on ENTER					
					try {
						document.getElementById('acp_magento_search_id_main_page').blur();
					} catch (e) {}
				}
				
				return false; // to avoid adding the URL to history again ending with #
			}
		}
	}


	function containsAllAscii(str) {
		return  /^[\000-\177]*$/.test(str) ;
	}

	function highlightWords( line, term, response_for, stem_words) {
		var term = term;
		if (response_for)	{	term = response_for;	}
		var words = term.split(' ');
		if (stem_words){
			for (var i = 0; i < stem_words.length; i++){
				if (words.indexOf(stem_words[i]) == -1){
					words.push(stem_words[i])
				}
			}
		}
		for (var i = 0; i < words.length; i++ ) {
			var word = words[i];
			if (word.length <= 1 || !containsAllAscii(word))
				continue;
			try	{
				var regular_expression = new RegExp('\\b(' + word + ')\\b(?![^\<]*\>)', "gim");
				line = line.replace( regular_expression, '<span class="search_res_item_highlight">$1</span>' );
			} catch (e)	{}
		}
		
		return line;
	}


	var isp_response_cache = {};
	function get_isp_response_cache_key( term, page, narrow, sort_by )	{
		return js_trim(term.toLowerCase()) + '^' + page + '^' + narrow + '^' + sort_by; 
	}

	function do_faceted_search2(event, element)	{
		do_faceted_search(element);
		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();
		try {
			// some themes might not auto-close the dropdown
			$jquery_isp(element).parent().parent().parent().removeClass('open');
		} catch (e) {}
	}

	function do_faceted_search(element)	{
		var facet_name  = element.getAttribute('facet_name');
		var facet_value = element.getAttribute('facet_value');
		if (facet_value == '') {
			facet_value = null;
		}
		add_facet_name_and_value(facet_name, facet_value, true);
		do_full_text_search( latest_full_text_search, 1, 0, false );	
		return false;	
	}

	function add_facet_name_and_value(facet_name, facet_value, selected) {
		for (var i = 0; i < FACETS_DATA.length; i++) {
			if (facet_name == 'isp_clear_all_facets'){
				FACETS_DATA[i][2] = null;
				FACETS_ORDERED_SELECTIONS = [];
				continue;
			}
			if (FACETS_DATA[i][0] == facet_name) {
				if (facet_value == null){
					FACETS_DATA[i][2] = null;
					continue;
				}
				if (selected && FACETS_DATA[i][2] != null && FACETS_DATA[i][2].indexOf(facet_value) > -1){
					// marked facet value chosen -> removing this filter
					var facet_value_index = FACETS_DATA[i][2].indexOf(facet_value);
					FACETS_DATA[i][2].splice(facet_value_index, 1);
				} else {
					if (FACETS_DATA[i][2] == null || FACETS_DATA[i][2].length < 1){
						FACETS_DATA[i][2] = [facet_value];
					} else {
						if (FACETS_DATA[i][2].indexOf(facet_value) < 0){
							// only if not duplacate of existed
							FACETS_DATA[i][2].push(facet_value);  
						}
					}
					if (selected){
						addFilterRemovableTag(facet_name, facet_value, getActualFacetDisplayValue(facet_name, facet_value));
					}
				}
				
				var new_selections = [];
				for (var j = 0; j < FACETS_DATA.length; j++) {
					if (FACETS_DATA[j][0] != facet_name && FACETS_DATA[j][2] != null){  // not current and has value
						new_selections.push([j]);
					}
				}
				
				if (facet_value != null) {
					new_selections.push([i]);
				}
				FACETS_ORDERED_SELECTIONS = new_selections;
				break;
			}
		}
	}

	function set_facets_from_narrow_string(narrow_string) {
		// cleaning current choice 
		for (var i = 0; i < FACETS_DATA.length; i++) {
				FACETS_DATA[i][2] = null;
		}
		FACETS_ORDERED_SELECTIONS = [];
		if (narrow_string != '') {
			var narrow = JSON.parse(narrow_string);
			for (var i = 0; i < narrow.length; i++) {
				add_facet_name_and_value(narrow[i][0], narrow[i][1], false);
			}
		}
	}

	function is_IE(v) {
		try {
			var r = RegExp('msie' + (!isNaN(v) ? ('\\s' + v) : ''), 'i');
			return r.test(navigator.userAgent);
		} catch (e) {
			return false;
		}
	}

	function get_narrow_value(data_narrow, facet_name) {
		if (data_narrow == null) {
			return null;
		}
		narrow_values = [];
		for (var i = 0; i < data_narrow.length; i++) {
			var pair = data_narrow[i];
			if (pair[0] == facet_name) {
				narrow_values.push(pair[1]);
			}
		}
		if (narrow_values.length > 0){
			return narrow_values;
		} else { 
			return null;
		}
	}

	function get_narrow_string(data) {
		if (data.narrow == null) {
			return '';
		}
		var narrow = '[';
		for (var i = 0; i < data.narrow.length; i++) {
			var pair = data.narrow[i];
			narrow += '["' + pair[0] + '","' + pair[1] + '"]';
		}
		narrow += ']';
		return narrow;
	}

	function get_narrow_param() {
		var narrow = '';
		for (var j = 0; j < FACETS_ORDERED_SELECTIONS.length; j++) {
			var selected = FACETS_DATA[FACETS_ORDERED_SELECTIONS[j]];
			if (selected[2]){
				for (k = 0; k < selected[2].length; k++){
					if (narrow != '')	{ narrow += ',';	}
					narrow += '["' + selected[0] + '","' + selected[2][k] + '"]';
				}
			}
		}
		if (narrow != '') {
			narrow = '[' + narrow + ']';
		} else if (narrow_string != null) {
			narrow = narrow_string;
		}
		
		return narrow;
	}

	var ISP_VIEW_MODE_GLOBAL = 0;	// 0 for image grid, 1 for list
	var isp_results_mode_key = 'isp_results_mode';
	try {
		// old browsers might not work
		ISP_VIEW_MODE_GLOBAL = localStorage.getItem( isp_results_mode_key );
		if (ISP_VIEW_MODE_GLOBAL == null)	{	
			ISP_VIEW_MODE_GLOBAL = 0;	
			localStorage.setItem(isp_results_mode_key, ISP_VIEW_MODE_GLOBAL);
		}
	} catch (e)	{
		ISP_VIEW_MODE_GLOBAL = readCookie( isp_results_mode_key );
		if (ISP_VIEW_MODE_GLOBAL == null)	{	
			ISP_VIEW_MODE_GLOBAL = 0;	
			createCookie(isp_results_mode_key, ISP_VIEW_MODE_GLOBAL, 365);
		}
	}

	var ISP_DISABLE_FLIP_CARD   = 1;	// Disable Flip card view for the Grid mode
	/*
	// Removing flip effect - MARCH 15 2016
	var isp_results_page_disable_flip_card_effect_key = 'isp_results_page_disable_flip_card_effect';
	try {
		// old browsers might not work
		ISP_DISABLE_FLIP_CARD = localStorage.getItem( isp_results_page_disable_flip_card_effect_key );
		if (ISP_DISABLE_FLIP_CARD == null || ISP_DISABLE_FLIP_CARD=='true' )	{	
			ISP_DISABLE_FLIP_CARD = 1;	
			localStorage.setItem(isp_results_page_disable_flip_card_effect_key, ISP_DISABLE_FLIP_CARD);
		}
	} catch (e)	{
		ISP_DISABLE_FLIP_CARD = readCookie( isp_results_page_disable_flip_card_effect_key );
		if (ISP_DISABLE_FLIP_CARD == null)	{	
			ISP_DISABLE_FLIP_CARD = 1;	
			createCookie(isp_results_page_disable_flip_card_effect_key, ISP_DISABLE_FLIP_CARD, 365);
		}
	}
	*/

	var ISP_SHOW_SKU   = 0;	
	var isp_results_page_show_sku_key = 'isp_results_page_show_sku';
	try {
		// old browsers might not work
		ISP_SHOW_SKU = localStorage.getItem( isp_results_page_show_sku_key );
		if ( ISP_SHOW_SKU == '1' || ISP_SHOW_SKU == 'true' )	{	
			ISP_SHOW_SKU = 1;	
			localStorage.setItem(isp_results_page_show_sku_key, ISP_SHOW_SKU);
		}
	} catch (e)	{
		ISP_SHOW_SKU = readCookie( isp_results_page_show_sku_key );
		if (ISP_SHOW_SKU != null)	{	
			ISP_SHOW_SKU = 1;	
			createCookie(isp_results_page_show_sku_key, ISP_SHOW_SKU, 365);
		}
	}

	if (ISP_SHOW_SKU == 1)	{
		var sku_css = 'div.isp_info .isp_product_sku { display: block !important; }';
		injectCSS(sku_css);
	}


	function isp_highlight_mode()	{	
		if (ISP_VIEW_MODE_GLOBAL == 0)	{
			document.getElementById('isp_mode_grid').style.opacity = '1';
			document.getElementById('isp_mode_list').style.opacity = '0.3';	
		}	else	{
			document.getElementById('isp_mode_grid').style.opacity = '0.3';
			document.getElementById('isp_mode_list').style.opacity = '1';
		}
	}



	function isp_switch_mode( mode )	{
		toggleDropdown(0, false);	// remove the filter dropdown if shows
		
		if (mode == ISP_VIEW_MODE_GLOBAL)	{	return;	}
		ISP_VIEW_MODE_GLOBAL = mode;	
		latest_srch_res_data = null; // let's fool this so we will re-render according to the mode
		try {
			localStorage.setItem(isp_results_mode_key, ISP_VIEW_MODE_GLOBAL);	// old browsers might not work
		} catch (e) {
			createCookie(isp_results_mode_key, ISP_VIEW_MODE_GLOBAL, 365);
		}
		do_full_text_search( latest_full_text_search, 1, 0, false );
		isp_highlight_mode();	
	}

	function replace_html_chars(s)	{
		s = s.replace(/'/g, "&apos;").replace(/"/g, "&quot;").replace(/&/g, "&amp;")
		return s;
	}
	var latest_srch_res_data = null;
	var CURRENT_SEARCH_RESULTS_PAGE = 1;
	var CURRENT_SEARCH_TERM = null;

	function isp_facets_res(data) {
		if (data && data.facets && data.facets.length > 0)	{
			document.getElementById('isp_refine_title_id').style.display = '';		
			latest_srch_res_data = null;
			handleFacets(data);
		}	else	{
			if (data.p == 1)	{
				// Hide the facets pane refine by label completely!
				document.getElementById('isp_refine_title_id').style.display = 'none';		
			}
		}
	}

	function isp_srch_res_price_html(item, item_currency)	{
		if (ISP_AVOID_PRICE_NON_LOGIN_USERS || item.p == '')	{	return '';	}
		var ret  = '<span class="isp_price money" ';
			ret += ' data-currency="' + item_currency + '" ';
			ret += ' data-currency-' + item_currency.toLowerCase() + '="' + item.p + '">';
			ret += format_product_price( item, item_currency ) + '</span>';
			ret += format_product_price_compare_at( item, item_currency );
		return ret;
	}

	var over_capacity_key = 'isp_over_capacity_timestamp';
	try {
		var over_capacity_timestamp = localStorage.getItem(over_capacity_key);
		if (over_capacity_timestamp != null)	{
			var delta = new Date().getTime() - parseInt(over_capacity_timestamp, 10);
			if (delta < 1000*60*10)	{	// keep in localstorage for up to 10min from last data.over_capacity
				location.href = '/search?q=' + encodeURIComponent(data.term);
			}	else	{
				localStorage.removeItem(over_capacity_key)
			}
		}
	} catch (e)	{}

	function isp_get_callback_cache_key(page)	{
		return 'isp_callback_cache_' + page;
	}
	function isp_srch_res(data)	{
		//	Fire so we get a loopback on Ajax based SERP
		if (data && data.items && typeof(__isp_token)!="undefined")  {
			var enc_term = encodeURIComponent(data.term);
			var post_load_url = __isp_post_load_url + '?store_id=' + encodeURIComponent(store_id) +
						   '&UUID=' + encodeURIComponent(isp_uuid) + '&prev_up_type=4' +
						   '&original_search_query=' + enc_term + "&serp=" + enc_term + "&pagenum=" + data.p +
						   '&st=' + encodeURIComponent(__isp_token) + '&callback=_isp_post_load_cb';
			var session = __isp_get_session();
			if (session) {
				post_load_url += "&session=" + session['start'];
			}
			try {
				var force_personalization_enabled = localStorage.getItem('isp_force_personalization_enabled');
			} catch (e) {
				var force_personalization_enabled = null;
			}
			if (force_personalization_enabled !== null) {
				post_load_url += '&personalization_enabled=' + force_personalization_enabled;
			}
			if (isp_serp_start_time !== null)	{
				var delta = encodeURIComponent(Date.now() - isp_serp_start_time);
				post_load_url += '&ux_count=0&ux_max_latency=' + delta + '&ux_total_latency=' + delta;
				isp_serp_start_time = null;
			}
			if (isp_page_load_to_serp_load_latency !== null) {
				post_load_url += '&page_load_to_serp_load_latency=' + isp_page_load_to_serp_load_latency;
				isp_page_load_to_serp_load_latency = null;
			}
			if (isp_script_load_to_first_search_latency !== null) {
				post_load_url += '&script_load_to_first_search_latency=' + isp_script_load_to_first_search_latency;
				isp_script_load_to_first_search_latency = null;
			}
			var currTime = Date.now();
			if (typeof isp_first_full_text_search_time != 'undefined' && isp_first_full_text_search_time && isp_first_full_text_search_time != -1)  {
				var delta = encodeURIComponent(currTime - isp_first_full_text_search_time);
				isp_log('time until search returns: '+ delta);
				post_load_url += '&request_latency=' + delta;
				isp_first_full_text_search_time = -1;
			}
			if (typeof _isp_interval_was_needed != 'undefined') {
				post_load_url += '&interval_was_needed'
			}
			if (typeof _isp_timeout_was_needed != 'undefined') {
				post_load_url += '&timeout_was_needed'
			}
			var search_time = localStorage.getItem('isp_search_results_header_load_time');
			if (search_time) {
				search_time = Number(search_time);
				var delta = currTime - search_time;
				post_load_url += '&latency_from_search=' + delta;
				try {
					localStorage.removeItem('isp_search_results_header_load_time');
				}
				catch (e) {}
			}

			product_ids = []
			if (data.items.length > 0) {
			    product_ids = data.items.map(function (x) { return x.id })
			}
			post_load_url += '&products=' + product_ids;
			post_load_url += "&rescount=" + data.total_results
			injectJS(post_load_url);
		}


		try {
			sessionStorage.setItem(isp_get_callback_cache_key(data.p), JSON.stringify( data ));
		} catch (e){}
		
		if (data && data.over_capacity && data.over_capacity == true)	{
			location.href = '/search?q=' + encodeURIComponent(data.term);
			try	{	localStorage.setItem(over_capacity_key, new Date().getTime());	} catch (e)	{}
			return;
		}

		try {	localStorage.setItem('ISP_LATEST_FULL_TEXT_SEARCH_QUERY', data.term);	}	catch (e)	{}
		
		if (data && data.p)	{
			CURRENT_SEARCH_RESULTS_PAGE = data.p;
		}
		
		var res_sort_by = '';
		if ('sort_by' in data){
			res_sort_by = data.sort_by;
		}
		
		isp_log('isp_srch_res start with ' + data.p);
		var cache_key  = get_isp_response_cache_key( data.term, data.p, get_narrow_string(data), res_sort_by );
		isp_response_cache[ cache_key ] = data;	//	place in the local memory for further caching etc

		if (document.getElementById('acp_magento_search_id_main_page') == null || document.getElementById('search_res_progress') == null)	{
			isp_log('isp_srch_res doc not ready yet');
			return;	// document is not ready yet
		}
		
		document.getElementById('search_res_progress').style.display = 'none';	// Hide progress gif
		var isp_more_hyperlink = document.getElementById('isp_more_hyperlink');
		if (isp_more_hyperlink != null)	{	isp_more_hyperlink.style.display = 'inline-block';	}
		document.getElementById('search_res_container').style.display = '';		// Show results...
		
		if (data.facets_completed) {
			if (JSON.stringify( latest_srch_res_data ) == JSON.stringify( data ))	{	
				isp_log('isp_srch_res exact response rendered already');
				return;		// we've rendered this very exact response and not in the initial progress showing up
			}	
			latest_srch_res_data = data;
		}
		
		if (data && data.p == 1 && data.term != CURRENT_SEARCH_TERM)	{
			clear_facets();
		}
		
		if (data && data.term)	{
			CURRENT_SEARCH_TERM = data.term;
		}	
		
		var cont 		= document.getElementById('search_res_container');
		var cont_header = document.getElementById('search_res_header');
		var html = '';
		var html_header = '';
		var MAX_FACET_OPTIONS = 10;
		if (isp_is_mobile_v1 == '1')	{	MAX_FACET_OPTIONS = 5;	}
		if (data)	{
			if ((data.facets && data.facets.length) > 0 || data.facets_completed == false)	{
				document.getElementById('isp_refine_title_id').style.display = '';		
				if (data.facets_completed) {
					handleFacets(data);
				} else {
					submit_search_query(data.term, 1, false, 2, 1)
				}			
			}	else	{			
				if (data.p == 1)	{
					// Hide the facets pane "refine by label" completely if the first page
					document.getElementById('isp_refine_title_id').style.display = 'none';		
				}
			}
			
			if ("total_results" in data){
				var total_search_results = "<b>" + data.total_results + "</b>";
			} else {
				var total_search_results = "";
			}
			
			if (data.items)	{
				if (data.items.length > 0)	{
					if (data.p == 1)	{
						html_header += '<div class="search_res_found">';					
						//var results_host_filler = '<span class="search_res_found_site_url">' +  getJSvars('acp-magento.js', 'shop', '') + '</span>';
						
						if (data.results_for && data.results_for != data.term)	{
							var search_results_for_text = SEARCH_RESULTS_FOR_TEXT + ' &quot;' + data.results_for + '&quot;';
							document.getElementById('search_res_header').style.display = '';
							html_header += getNoSearchResultsMessage(data.term, data.results_for);
							html_header += getSearchResultsForMessage(data.results_for, total_search_results);
						}	else	{
							var search_results_for_text = SEARCH_RESULTS_FOR_TEXT + ' &quot;' + data.term + '&quot;';
							document.getElementById('search_res_header').style.display = '';
							html_header += getSearchResultsForMessage(data.term, total_search_results);
						}
						var page_title_ele = $jquery_isp('h1#page-title, #main #page-content h1, main.main-content div.grid div.grid-item h1');
						if (page_title_ele.length == 1)	{
							page_title_ele.each(function(index) { 								
									this.innerHTML = search_results_for_text;	
									this.style.marginBottom = '5px';							
							})
						} else	{
						
						
						}
						
						// if (MOBILE_ENDPOINT == '0')	{	html_header += ' (' +  results_host_filler + ')';	} */					
						html_header += '</div>';
						
						// Sorting out the related_search if appended to the end of the alternatives after the #related_search# dummy array item
						if (data.related_search == null)	{												
							if (data.alternatives)	{
								for (var i=0;i<data.alternatives.length;i++)	{
									if (data.alternatives[i] == '#related_search#')	{
										data.related_search = new Array();
										data.related_search = data.alternatives.splice(i+1);	// Get the terms post #related_search# as related
										data.alternatives = data.alternatives.splice(0,i);		// Drop the #related_search# item
										break;
									}
								}	
							}
						}
						
						// Related searches as first priority
						var found_related = false;
						if (data.related_search && data.related_search.length > 0)  {
							found_related = true;							
							html_header += getRelatedSearchesMessage();
							for (var d=0; d < data.related_search.length; d++)	{
								if (d != 0)	{	
									html_header += ', ';	
								}
								html_header += '<a class="search_res_found_highlight" href="/pages/filter-search?q=' + encodeURIComponent(data.related_search[d]) + '&isp_related_srch=1">' + data.related_search[d] + '</a>';
							}	
							document.getElementById('search_res_header').style.display = '';
						}
							
						if (!found_related && data.alternatives && data.alternatives.length > 0)	{
							html_header += getDidYouMeanLanguageMessage();
							for (var d=0; d < data.alternatives.length; d++)	{
								if (d != 0)	{	
									html_header += ', ';	
								}
								html_header += '<a class="search_res_found_highlight" href="/pages/filter-search?q=' + encodeURIComponent(data.alternatives[d]) + '&isp_didyoumean_srch=1">' + data.alternatives[d] + '</a>';
							}	
							document.getElementById('search_res_header').style.display = '';
						}
					}	else	{
						// Next>> paging...
						html = cont.innerHTML;
					}
					
					var limit_usage = false;
					if (data.limit_usage)	{	limit_usage = true;	}				
					var selected_index = 0;
					if (data.p)	{	selected_index += 4*(parseInt(data.p, 10)-1);		}

					var search_res_item_snippet_mobile = '';
					if (isp_is_mobile_v1 == '1')	{	search_res_item_snippet_mobile = ' search_res_item_snippet_mobile ';	}
									
					if (ISP_VIEW_MODE_GLOBAL==0)	{
						document.getElementById('search_res_container').setAttribute('class', 'search_res_container_grid');
					}	else	{
						document.getElementById('search_res_container').setAttribute('class', 'search_res_container_list');
					}
					
					document.getElementById('search_facets_container').style.display = 'inline-table';	// show the facet bar when there ARE search results
					
					var rendered_items_urls = {};	// temporary dictionary so we can ferret out duplicate products urls
					
					for (var i=0;i<data.items.length;i++)	{
						selected_index += 1;
						if (data.items[i].p == null)	{
							continue;	// probably a turbolink... let's skip
						}
						
						var item_title    = data.items[i].l;
						var item_url 	  = data.items[i].u;
						var item_image	  = data.items[i].t;
						var variants_count = data.items[i].v_c;
						
						if (item_url in rendered_items_urls)	{							
							continue;	// already rendered...
						}	else	{	
							rendered_items_urls[item_url] = 1;
						}
						
						var item_identifier = 0;
						var product_identifier = 0;
						try {
							item_identifier = data.items[i].s.split('::')[1];
							product_identifier = data.items[i].s.split('::')[0];
							if (typeof window.yotpo != "undefined" && window.yotpo.appKey && product_identifier != 0)	{
								var isp_yotpo_callback = "__isp_yotpo___" + product_identifier;
								injectJS('//api.yotpo.com/products/' + yotpo.appKey + '/' + product_identifier + '/bottomline?callback=' + isp_yotpo_callback);
								window[isp_yotpo_callback]  = function (data)	{ 
									if (document && document.currentScript && document.currentScript.src)	{
										// IE11 is breaking this 
										var s_src = document.currentScript.src;
										var del_pos = s_src.indexOf('___');
										var product_identifier = s_src.substr(del_pos+3);
										render_yotpo_stars(data, product_identifier);
									}
								};						
							}
						} catch (e)	{}
						var show_add_to_cart = true;
						
						if (item_identifier == 0 || isp_results_page_disable_add_to_cart == true || isp_is_mobile_v1 == '1')	{
							// Don't show add to cart in mobile views
							show_add_to_cart = false;
						}
						
						var isp_store_pos = '';					
						try {
							var product_position = (data.items.length*(data.p-1))+(i+1);
						} catch (e) {
							var product_position = i+1;
						}
						if (product_identifier != 0)	{
							isp_store_pos = ' onclick="' + isp_on_submit_expr(product_identifier, product_position, data.term, data.narrow, data.sort_by)+ '" ';
						}
						
						if (true && data.items[i].t2)	{	// ISP_VIEW_MODE_GLOBAL==0 && data.items[i].t2)	{ // always do the Shopify CDN image
							// full image for the full text grid mode 
							item_image = data.items[i].t2.replace('http://', 'https://');
						}					
						var item_currency = data.items[i].c;
						var item_snippet  = highlightWords( data.items[i].d, data.term, data.results_for, data.stem_words);	// replace_html_chars( data.items[i].d ), replace_html_chars( data.term ) );
						if (item_title == '') {	
							item_title = item_url;
						} else {
							item_title = highlightWords( item_title, data.term, data.results_for, data.stem_words);	//  replace_html_chars( item_title ), replace_html_chars( data.term ));
						}
						var sku = '';
						if (data.items[i].sku)	{	sku = data.items[i].sku;	}
						if (ISP_VIEW_MODE_GLOBAL==1 )	{
							// List style
							html += '<div class="row results" style="display:flex; margin:0;" ';
							if (show_add_to_cart)	{ 
								html += 'onmouseover="add_to_cart_hover(true, ' + item_identifier + ',0)" onmouseout="add_to_cart_hover(false, ' + item_identifier + ',0)" '; 
							}
							html += '>';
							html += '<table style="margin:0;border:none;background:none">'
							html += 	'<tr style="background:none;border:none;"><td class="isp_list_image_container">';
							html += 		'<div class="isp_search_res_img_container">';
							html +=            '<div class="isp_thumbnail">';
							html += 			'<a ' + isp_store_pos + ' href="' + item_url + '"><img onerror="isp_thumb_error(this, ' + ISP_VIEW_MODE_GLOBAL + ')" src="' + item_image + '" class="isp_search_res_img" /></a>';
							html += 		'</div></div>';
							html += 	'</td>';
							html += 	'<td class="isp_list_info_container">';
							html += 		'<div style="width:auto; display:inline-block; float:none; vertical-align:top; margin:0 ">';					
							html += 			'<div class="isp_search-result" style="text-align:left">';
							html += 				'<div class="search_res_item_variants_count">' + variants_count + '</div>';					
							html += 				'<div class="search_res_item_title">';
							html += 					'<a ' + isp_store_pos + ' href="' + item_url + '" class="isp_href_title">' + item_title + '</a>';
							if (show_add_to_cart)	{
								html += 		'<form id="form_' + item_identifier + '" onsubmit="' + isp_on_submit_expr(product_identifier, product_position, data.term, data.narrow, data.sort_by) + 
														  '" class="isp_add_to_cart_form_list" action="/cart/add" method="post">';
								html +=				'<input name="id" type="hidden" value="' + item_identifier +'">';						
								html += 			'<input type="submit" value="' + add_to_cart_text + '" name="button" class="isp_add_to_cart_list_btn">';
								html += 		'</form>';
							}
							html += 				'</div>';					
							html += 				'<div class="search_res_item_snippet ' + search_res_item_snippet_mobile + '">' + item_snippet + '</b></div>';	 // close the bold section anyways in case left open
							html += 				'<div class="search_res_item_price"><b>' + isp_srch_res_price_html( data.items[i], item_currency )+ '</b>';
							
							
							
							html += 		'</div>';											
							html += 		'</div></div>';	
							html += 	'</td></tr>';					
							html += '</table></div>';
						}	else	{
							// Grid style
							if (ISP_DISABLE_FLIP_CARD == 1)	{
								// Classic grid style
								html += '<div class="isp_grid_result" ';
								if (show_add_to_cart)	{ 
									html += 'onmouseover="add_to_cart_hover(true, ' + item_identifier + ',1)" onmouseout="add_to_cart_hover(false, ' + item_identifier + ',1)" '; 
								}
								html += '>';
								if (show_add_to_cart)	{
									html += 		'<form id="form_' + item_identifier + '" onsubmit="' + isp_on_submit_expr(product_identifier, product_position, data.term, data.narrow, data.sort_by) + 
															'" class="isp_add_to_cart_form" action="/cart/add" method="post">';
									html +=				'<input name="id" type="hidden" value="' + item_identifier +'">';						
									html += 			'<input type="submit" value="' + add_to_cart_text + '" name="button" class="isp_add_to_cart_btn">';
									html += 		'</form>';
								}
								
								html += 	'<a ' + isp_store_pos + ' href="' + item_url + '" >';
								html +=			'<div class="isp_image_div">';						
								html +=				'<img onerror="isp_thumb_error(this, ' + ISP_VIEW_MODE_GLOBAL + ')" src="' + item_image + '" class="isp_search_res_img" /></div>';
								html +=			'<div class="isp_info">';
								html += 			'<span class="isp_variants_count">' + variants_count + '</span>';
								html += 			'<span class="isp_title">' + item_title + '</span>';
								html +=             '<div class="isp_product_sku"><span class="isp_product_sku_title">SKU: </span>' + sku + '</div>';							
								if (product_identifier != 0)	{
									html += 		'<div class="isp_yotpo" id="isp_yotpo_' + product_identifier + '"></div>';
								}
								html += 			'<span class="isp_desc">' + item_snippet + '</span>';
								html += 			isp_srch_res_price_html(data.items[i], item_currency );
													
								html += 		'</div>';
								html +=		'</a>';
								html += '</div>';
							}	else	{
								// Flip card style...
								html += '<div class="isp_grid_result isp_flip-container" ';
								if (show_add_to_cart)	{ 
									html += 'onmouseover="add_to_cart_hover(true, ' + item_identifier + ',1)" onmouseout="add_to_cart_hover(false, ' + item_identifier + ',1)" '; 
								}
								html += '>';
								html += ' <div class="isp_flipper">';
								
								html += ' <div class="isp_front">';
								html += 	'<a ' + isp_store_pos + ' href="' + item_url + '" >';
								html +=			'<div class="isp_image_div">';						
								html +=				'<img onerror="isp_thumb_error(this, ' + ISP_VIEW_MODE_GLOBAL + ')" src="' + item_image + '" class="isp_search_res_img" /></div>';
								html +=			'<div class="isp_info">';
								html += 			'<span class="isp_variants_count">' + variants_count + '</span>';
								html += 			'<span class="isp_title">' + item_title + '</span>';
								if (product_identifier != 0)	{
									html += 		'<div class="isp_yotpo" id="isp_yotpo_' + product_identifier + '"></div>';
								}
								html += 			'<span class="isp_desc">' + item_snippet + '</span>';
								html += 			isp_srch_res_price_html(data.items[i], item_currency );
								html += 		'</div>';
								html +=		'</a>';
								html += ' </div>';	//	isp_front END
								
								html += ' <div class="isp_back">';
								if (show_add_to_cart)	{
									html += 		'<form id="form_' + item_identifier + '" onsubmit="' + isp_on_submit_expr(product_identifier, product_position, data.term, data.narrow, data.sort_by) + 
															 '" class="isp_add_to_cart_form" action="/cart/add" method="post">';
									html +=				'<input name="id" type="hidden" value="' + item_identifier +'">';						
									html += 			'<input type="submit" value="' + add_to_cart_text + '" name="button" class="isp_add_to_cart_btn">';
									html += 		'</form>';
								}
								html += 	'<a ' + isp_store_pos + ' href="' + item_url + '" >';
								html +=			'<div class="isp_image_div">';						
								html +=				'<img onerror="isp_thumb_error(this, ' + ISP_VIEW_MODE_GLOBAL + ')" src="' + item_image + '" class="isp_search_res_img" /></div>';
								html +=			'<div class="isp_info">';
								html += 			'<span class="isp_variants_count">' + variants_count + '</span>';
								html += 			'<span class="isp_title">' + item_title + '</span>';
								if (product_identifier != 0)	{
									html += 		'<div class="isp_yotpo_back" id="isp_yotpo_back_' + product_identifier + '"></div>';
								}
								html += 			'<span class="isp_desc">' + item_snippet + '</span>';
								html += 			isp_srch_res_price_html(data.items[i], item_currency );
								html += 		'</div>';
								html +=		'</a>';
								html += ' </div>';	// isp_back END
								
								html += ' </div>';	// isp_flipper
								html += '</div>';
							}
						}						
					}	
					handleSortingDisplay(data);
				}	else	{				
					
					if (data.term!='' && data.p == 1)	{		
						document.getElementById('search_facets_container').style.display = 'none';	// Don't show the facet bar when there are no search results
						var cont = document.getElementById('search_res_container');
						var no_results_host_filler = '<span class="search_res_not_found_site_url">' +  getJSvars('acp-magento.js', 'shop', '') + '</span>';
						html_header  = '<div class="search_res_not_found">';
						var this_term = stripHTML(data.term);
						html_header +=	'<span class="search_res_not_found_msg">' + no_results_text + ' &quot;<span class="search_res_not_found_highlight">' + this_term + '</span>&quot;<br>';					
						if (false && data.didyoumean && data.didyoumean.length>0){
							html_header += '<span class="search_res_did_you_mean">Did you mean <a href="#" onclick="api_openURL_modal(\'' + data.didyoumean[0].value + '\', \'tab\', false)">' + data.didyoumean[0].label + '</a></span><br>';
						}
						html_header += '</span>';					
						html_header += '</div>';					
						html_header += no_results_suggestion_text;		 // No results suggestions text																					
						cont.innerHTML = html;	
					}
					clearSortingDisplay();
				}			
			}
			if (data.p == 1)	{
				cont_header.innerHTML = html_header;	
			}
				
			
			var pager_html = '';
			if (data.tp && data.tp > 1 && data.p < data.tp)	{
				pager_html += '<div id="next_pager_" class="search_footer_paging">'; 
				pager_html += '&nbsp; <span class="search_pager"><center><a id="isp_more_hyperlink" style="color:inherit" href="#!" onclick="isp_change_page(' + (data.p+1) + ')">' + more_nav_text + '</a></center></span>';
				pager_html += '</div>';
			}	else	{
				pager_html += '<div id="next_pager_empty" class="search_footer_paging">&nbsp;</div>';		
			}
			
			document.getElementById('search_res_container_pager').innerHTML = pager_html;		

			
			
		}
				
		if (data.p > 1)	{	
			if (ISP_VIEW_MODE_GLOBAL == 0) {
				// smooth_scroll(cont.scrollTop, document.getElementById('search_res_container_pager').offsetHeight  ); 
			}	else	{
				// smooth_scroll(cont.scrollTop, cont.offsetHeight - screen.height );			
			}
		}	
		if ( data.p > 1 && html == '')	{	
			// overcome the weird situation in which a later page has no results
			// No need to assign the html, draw the progress gif per each result, spread the results boxes on the grid, etc...
			return;
		}
		cont.innerHTML = html;
		
		if (typeof Currency!="undefined" && typeof Currency.convertAll != "undefined")	{
			// Shopify built-in currency converter widget: http://docs.shopify.com/manual/configuration/store-customization/currencies-and-translations/currencies/how-to-show-multiple-currencies
			if (data.items.length > 0)	{
				var cookieCurrency = Currency.cookie.read();
				if (cookieCurrency!=null && cookieCurrency!='null' && data.items[0].c != cookieCurrency)	{
					Currency.convertAll(data.items[0].c, cookieCurrency, 'span.money');
				}
			}
		}
		
		
		// Progress gif for each of the results
		setTimeout(function()	{
									$jquery_isp('.isp_image_div, isp_search_res_img_container').each( function(){ 
												this.style.backgroundImage = "url('https://acp-magento.appspot.com/images/progress.gif')"; 
												this.style.backgroundRepeat = 'no-repeat'; 
												this.style.backgroundPosition ='center';
									} );					
								}, 11);
		setTimeout(function()	{	// Hide it in 2sec anyways to avoid transparent thumbnails
					$jquery_isp('.isp_image_div, isp_search_res_img_container').each( function(){ this.style.background = 'none'; 	});	}, 
					1500);	
						
		var scroll = sessionStorage.getItem(cache_key);
		if (scroll) {
			window.scrollTo(0, scroll);
			sessionStorage.removeItem(cache_key);
		}
		
		// spread the grid boxes evenly
		if (ISP_VIEW_MODE_GLOBAL==0)	{						
			var t = $jquery_isp('#search_res_container').width();
			var box_per_row = parseInt(t/200, 10);			
			$jquery_isp('.isp_grid_result').outerWidth( t/box_per_row - box_per_row - 2 ); 
		}				
	}

	function isp_on_submit_store(product_identifier, product_position, term, narrow_by, sort_by) {
		try {
			localStorage.setItem('isp_add_to_cart_serp_product_id', product_identifier);	// will mark the event to be known to the server upon the next /load event
			ispStoreProductData(product_identifier, product_position, term, narrow_by, sort_by);
		}	catch (e)	{}
		try {
			sessionStorage.setItem('isp_last_query_results', document.getElementById('isp_container'));	// will mark the event to be known to the server upon the next /load event
		} catch (e) {}
	}

	function isp_on_submit_expr(product_id, product_position, term, narrow_by, sort_by) {
		try {
			product_id = Number(product_id);
		} catch (e) {}
		var args = JSON.stringify([product_id, product_position, term, narrow_by, sort_by]);
		args = args.substr(1, args.length - 2); // remove the '[' and ']' marks
		return ispEscapeHtml("isp_on_submit_store(" + args + ")");
	}

	function ispStoreProductData(product_id, product_position, term, narrow_by, sort_by) {
		try { 
			var store = { 'position'   : product_position,
						  'search_term': term,
						  'narrow_by'  : narrow_by,
						  'sort_by'    : sort_by};
			createCookie('isp_serp_product_' + product_id, JSON.stringify(store), 0.01);
	   } catch (e) {}
	}

	function ispEscapeHtml(str) {
		return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#039;");
	 }

	function ispStoreProductDataExpr(product_id, product_position, term, narrow_by, sort_by) {
		try {
			product_id = Number(product_id);
		} catch (e) {}
		var args = JSON.stringify([product_id, product_position, term, narrow_by, sort_by]);
		args = args.substr(1, args.length - 2); // remove the '[' and ']' marks
		return ispEscapeHtml("ispStoreProductData(" + args + ")");
	}

	function add_to_cart_hover(hover, identifier, type)	{
		var obj = document.getElementById('form_' + identifier);
		if (hover)	{
			if (type==0)	{	obj.style.display = 'inline-block'; }
			else			{	obj.style.display = 'inline'; }
		}	else	{
			obj.style.display = 'none';
		}
	}

	function handleFacets(data) {
		if (isp_is_mobile_v1 == '1') { 		
			document.getElementById('isp_refine_title_id').style.display = 'none'; 
		}	else	{
			document.getElementById('isp_refine_title_id').style.display = ''; 
		}
		var SUPPORTED_FACETS_COUNT = 1;
		for (var f = 1; f <= NUM_MAX_FACETS; f++) {
			if (document.getElementById('facet_drop_container_' + f))	{
				document.getElementById('facet_drop_container_' + f).style.display = 'none';
			}
		}
		
		data_narrow = data.narrow;
		if (data_narrow != null && data_narrow != '' && typeof data_narrow == 'string'){
			narrow_string = data_narrow;
			data_narrow = JSON.parse(data_narrow);
		} else if (data_narrow != null && data_narrow != '' && typeof data_narrow == 'object') {
			narrow_string = JSON.stringify(data_narrow);
		} else {
			narrow_string = '';
		}
		
		FACETS_DATA = [];
		var total_chosen_filters = 0;
		// reset all filter tags!
		$jquery_isp('div#search_res_filter_tags').html('')
		for (var j = 0; j < data.facets.length; j++) {
			var facet_name = data.facets[j][0];
			if (facet_name.toLowerCase() == 'price_min' || facet_name.toLowerCase() == 'price_max' ||
			    facet_name == "Isp-in-stock"){
				continue;
			}
			var actual_name = "";
			if (data.facets[j].length > 2) {
				actual_name = data.facets[j][2];
			} else {
				var all_names = facet_name.split(';');
				for (var i=0;i<all_names.length;i++)	{
					var trimmed = all_names[i].trim();
					if (trimmed.length > 0) {
						actual_name = trimmed;
						break;
					}
				}
			}

			// All [facet_name]
			var	selected_facet_value_css_class = ' class="selected_facet_value" ';
			var narrow_value = get_narrow_value(data_narrow, facet_name);
			if (narrow_value)	{	// Something else is selected in this facet					
				selected_facet_value_css_class = '';
			}
			var facet_drop_list_html = '<li role="presentation" style="list-style:none">'
									  + '<a facet_name="' + facet_name + '" facet_value=""' + selected_facet_value_css_class + ' style="padding-left:24px" role="menuitem" tabindex="-1" onclick="do_faceted_search2(event, this)" href="#!">' + any_facet_text + ' ' + actual_name.toLowerCase() + '</a></li>';
			
			var current_facet_data = [facet_name, actual_name, narrow_value];
			FACETS_DATA.push(current_facet_data);

			var facet_drop_name = 'facet_drop_name_' + SUPPORTED_FACETS_COUNT;
			
			document.getElementById('facet_drop_container_' + SUPPORTED_FACETS_COUNT).style.display = '';
			document.getElementById(facet_drop_name).innerHTML = actual_name.charAt(0).toUpperCase() + actual_name.slice(1); // capitalize
			
			var facet_values = data.facets[j][1];
			for (var k = 0; k < facet_values.length; k++)	{				
				var facet_value =  facet_values[k] ;	
				var facet_option;
				var is_color_facet = false;	
				var actual_value;
				if (facet_name == 'Categories' && facet_value.length > 2){
					actual_value = getActualFacetDisplayValue(facet_name, facet_value[2]);
				} else {
					actual_value = getActualFacetDisplayValue(facet_name, facet_value[0]);
				}

				if (String(facet_value[0]).match(COLOR_FACET_REGEX))	{
					// Color facet...
					is_color_facet = true;
					facet_option = '<table><tbody><tr><td><span  class="color_facet" style="background-color:' + actual_value + '"> </span></td>'
								 + ' <td> &nbsp; (' + facet_value[1] + ')</td></tr></tbody></table>';
				} else {
					facet_option = actual_value + ' (' + facet_value[1] +')';
				}

				selected_facet_value_css_class = '';
				if (narrow_value != null && $jquery_isp.inArray(facet_value[0], narrow_value) > -1){
					selected_facet_value_css_class = ' class="selected_facet_value" ';				
					// add removable filter's tag below the filters menu
					addFilterRemovableTag(facet_name, facet_value[0], actual_value);
					total_chosen_filters++;
				}
									
				facet_drop_list_html += '<li role="presentation" style="list-style:none">' + '<a facet_name="' + facet_name +
										'" facet_value="' + facet_value[0] + '"' + selected_facet_value_css_class +
										' style="padding-left:24px" role="menuitem" tabindex="-1" onclick="do_faceted_search2(event, this)" href="#!">' + 
										facet_option + '</a></li>';
			}				
			document.getElementById('facet_drop_list_' + SUPPORTED_FACETS_COUNT).innerHTML = facet_drop_list_html;				
			SUPPORTED_FACETS_COUNT += 1;
			if (SUPPORTED_FACETS_COUNT > NUM_MAX_FACETS) {
				break;
			}
		}

		if (narrow_string != null && narrow_string != '') {
			set_facets_from_narrow_string(narrow_string);
			narrow_string = '';
		}
		if (total_chosen_filters){
			addFilterTagRemoveAll();
		}
	}

	function addFilterRemovableTag(facet_name, facet_value, actual_value){
		var filter_tag_html = '<span class="filter_removable_tag"> ' + actual_value + ' &nbsp;<a facet_name="'+ facet_name +'" facet_value ="'+ facet_value +'" onclick="do_faceted_search2(event, this)">&#10006;</a></span>&nbsp;&nbsp;';
		if ($jquery_isp('div#search_res_filter_tags').html() == undefined){
			$jquery_isp('div#search_res_filter_tags').html(filter_tag_html);
		} else {
			if ($jquery_isp('div#search_res_filter_tags').children().last().attr('class') != "filter_tag_remove_all"){
				$jquery_isp('div#search_res_filter_tags').html($jquery_isp('div#search_res_filter_tags').html() + filter_tag_html);
			} else {
				$jquery_isp('div#search_res_filter_tags').children().last().before(filter_tag_html);
			}    
		}
	}
	function addFilterTagRemoveAll(){
	//  do_full_text_search( latest_full_text_search, 1, 0, false );
		var filter_tag_html = '&nbsp;<span class="filter_tag_remove_all"><a facet_name="isp_clear_all_facets" facet_value ="" onclick="do_faceted_search2( event, this )"> ' + clear_all_text + '</a></span>';
	//    $jquery_isp('div#search_res_filter_tags').last().after(filter_tag_html);  
		$jquery_isp('div#search_res_filter_tags').html($jquery_isp('div#search_res_filter_tags').html() + filter_tag_html);
	}

	function getActualFacetDisplayValue(facet_name, facet_value){
		var actual_value = String( facet_value ).split(';')[0];  
		if (facet_name == "Price") {
			var new_actual = "";
			var prices = actual_value.split('-');
			for (var l = 0; l < prices.length; l++) {
				if (l > 0) {
					new_actual += ' - ';
				}
				price_comps = prices[l].split(':');
				new_actual += getCurrencyPreSymbol(price_comps[0]);
				new_actual += price_comps[1];
				new_actual += getCurrencyPostSymbol(price_comps[0]);
			}
			actual_value = new_actual;
		}
		return actual_value
	}

	function isScrolledIntoView(elem){
		var docViewTop = $jquery_isp(window).scrollTop();
		var docViewBottom = docViewTop + $jquery_isp(window).height();
		var document_heigth = $jquery_isp(document).height();
		
		return ((docViewBottom) >= (document_heigth * 0.65))
		
	//    var elemTop = $jquery_isp(elem).offset().top;
	//    var elemBottom = elemTop + $jquery_isp(elem).height();
	//
	//    return ((elemBottom <= docViewBottom))	// Some bug int he grid view prevents the elemTop to be precise... && (elemTop >= docViewTop));
	}

	if (typeof($jquery_isp) !== 'undefined') {
		$jquery_isp(window).scroll(function() {	
		   if (	document.getElementById('next_pager_') != null &&
				document.getElementById('next_pager_').style.display == '' &&
				isScrolledIntoView('#next_pager_') ) {	// ($jquery_isp(window).scrollTop() + $jquery_isp(window).height() > $jquery_isp(document).height() - 100) && 
			   isp_change_page(CURRENT_SEARCH_RESULTS_PAGE +1);
		   }
		});
	}
	
	function isp_thumb_error(image, view_mode)	{
		image.onerror = '';
		if (view_mode == 1)	{
			var product_hyperlink = image.parentNode.href;
		}	else	{
			var product_hyperlink = image.parentNode.parentNode.href;
		}
		
		$jquery_isp.ajax({
		  url: product_hyperlink, 
		  error: function(xhr, status) {
			if (view_mode == 1)	{
				image.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.style.display = 'none';
			}	else	{
				if (ISP_DISABLE_FLIP_CARD != 1)	{
					image.parentNode.parentNode.parentNode.parentNode.parentNode.style.display = 'none';
				} else	{
					image.parentNode.parentNode.parentNode.style.display = 'none';
				}
			}
		  },
		  success: function(data) { 
			// try FB meta
			var images_str = '<meta property="og:image" content="';
			var images_pos = data.indexOf( images_str );
			if (images_pos > 0)	{
				var image_end = data.indexOf('"', images_pos + images_str.length + 1);
				if (image_end > 0)	{
					var image_url = data.substr(images_pos + images_str.length, image_end - (images_pos + images_str.length + 1));			
					image.src = image_url.replace('_large.', '_medium.')
				}
			}	else	{			
				var images_str = '"images":["';
				var images_pos = data.indexOf( images_str );
				if (images_pos > 0)	{
					var image_end = data.indexOf('"', images_pos + images_str.length + 1);
					if (image_end > 0)	{
						var image_url = data.substr(images_pos + images_str.length, image_end - (images_pos + images_str.length + 1));			
						image.src = image_url.replace('.jpg?', '_medium.jpg?').replace('.jpeg?', '_medium.jpeg?').replace('.png?', '_medium.png?');				
					}
				}				
			}
		  }  
		});
		return false;
	}

	var products_title = 'Products &amp; Categories';
	var pop_searches_title = 'Popular searches';
	var see_all_matching_text = 'All results for';
	var price_min_from_text = 'from';

	var refine_by_text = 'Refine by';

	var sort_by_title_text = 'Sort by';
	var sort_match_text = 'Best Match';
	var sort_price_low_to_high_text = 'Price: Low to High';
	var sort_price_high_to_low_text = 'Price: High to Low';
	var clear_all_text = 'Clear All';

	try	{	
		switch (navLang)	{
			case 'ro': 	see_all_matching_text = 'Toate rezultatele pentru';	price_min_from_text = 'de la';
			products_title = 'produse și categorii'; pop_searches_title = 'căutări populare';	sort_by_title_text = 'sorteaza dupa'; sort_match_text = 'Recomandate'; sort_price_high_to_low_text = 'Preţ: crescător'; sort_price_low_to_high_text = 'Preţ: descrescător';	refine_by_text = 'Filtrează';		
			break;	
			
			case 'fr': 	see_all_matching_text = 'Voir tous les résultats';	price_min_from_text = 'de';
			products_title = 'Produits et Catégories'; pop_searches_title = 'Recherches populaires';			
			break;		
			case 'az': 	see_all_matching_text = 'üçün bütün nəticələri göstər';	price_min_from_text = 'etibarən';
			products_title = 'Məhsullar&Kateqoriyalar'; pop_searches_title = 'məşhur axtarış';	
			sort_by_title_text = 'Düzülüşü ayarla'; sort_match_text = 'Uyuğunluğa görə'; sort_price_high_to_low_text = 'Qiymət: azdan çoxa'; sort_price_low_to_high_text = 'Qiymət: çoxdan aza';
			refine_by_text = 'Ayarla';
			break;
			case 'es':	
			case 'ca': refine_by_text ='Matizar por'; see_all_matching_text = 'Ver todas las coincidencias';	price_min_from_text = 'de';
			products_title = 'Productos y Categorías'; pop_searches_title = 'búsquedas más populares';
			sort_by_title_text = 'ordenar por'; sort_match_text = 'Mejor coincidencia'; sort_price_high_to_low_text = 'Precio: De mayor a menor'; sort_price_low_to_high_text = 'Precio: Menor a Mayor';
			break;
			case 'nl':  refine_by_text = 'Verfijnen door'; see_all_matching_text = 'Bekijk alle overeenkomende resultaten';	price_min_from_text = 'vanaf';
			products_title = 'Producten &amp; Categorieën'; pop_searches_title = 'populaire zoekopdrachten';
			sort_by_title_text = 'Sorteer op'; sort_match_text = 'Beste match'; sort_price_high_to_low_text = 'Prijs: hoog naar laag'; sort_price_low_to_high_text = 'Prijs: laag naar hoog';
			break;
			case 'de':  refine_by_text = 'Suche verfeinern mit'; see_all_matching_text = 'Alle passenden Ergebnisse';	price_min_from_text = 'ab';
			products_title = 'Produkte &amp; Kategorien'; pop_searches_title = 'Beliebte Suchen';
			sort_by_title_text = 'Sortieren nach'; sort_match_text = 'Bestens passend'; sort_price_high_to_low_text = 'Preis: Hoch bis niedrig'; sort_price_low_to_high_text = 'Preis: niedrig bis hoch';
			break;
			case 'he': 	refine_by_text = 'מיון לפי'; see_all_matching_text = 'ראה את כל התוצאות התואמות';	price_min_from_text = 'מתחיל ב-';
			products_title = 'מוצרים וקטגוריות'; 
			pop_searches_title = 'חיפושים פופולריים';
			break;
			case 'hu': 	see_all_matching_text = 'Lásd az összes találatot';	price_min_from_text = '-től';
			products_title = 'Termékek és kategóriák'; 
			pop_searches_title = 'Legnépszerűbb keresések';
			break;
			case 'it':	refine_by_text = 'Ricerca in base a';	see_all_matching_text = 'Vedi tutti i risultati corrispondenti';	price_min_from_text = 'da';
			products_title = 'Prodotti e Categorie'; 
			pop_searches_title = 'Ricerche più frequenti';
			sort_by_title_text = 'Ordina per'; sort_match_text = 'Miglior risultato'; sort_price_high_to_low_text = 'Prezzo decrescente'; sort_price_low_to_high_text = 'Prezzo: Crescente';
			break;
			case 'pl':	refine_by_text = 'Udoskonalenie przez'; see_all_matching_text = 'Zobacz wszystkie wyniki dopasowania';	price_min_from_text = 'z';
			products_title = 'Produkty i kategorie'; 
			pop_searches_title = 'Popularne wyszukiwania';
			break;
			case 'pt':	refine_by_text = 'Refinar por'; see_all_matching_text = 'Veja todos os resultados correspondentes';	price_min_from_text = 'de';
			products_title = 'Produtos e Categorias'; 
			pop_searches_title = 'Pesquisas populares';
			sort_by_title_text = 'Ordenar por'; sort_match_text = 'Melhor correspondência'; sort_price_high_to_low_text = 'Preço: Alto para baixo'; sort_price_low_to_high_text = 'Preço: Baixo para Alto';
			break;
			case 'ro':	refine_by_text = 'Rafina de'; see_all_matching_text = 'Vezi toate rezultatele care se potrivesc';	price_min_from_text = 'de la';
			products_title = 'Produse &amp; Categorii'; 
			pop_searches_title = 'Căutări populare';
			break;
			case 'ru':	refine_by_text = 'Фильтровать'; see_all_matching_text = 'Просмотреть все соответствующие результаты';	price_min_from_text = 'от';
			products_title = 'Продукты и категории'; 
			pop_searches_title = 'Популярные запросы';
			sort_by_title_text = 'сортировать по'; sort_match_text = 'лучшее совпадение'; sort_price_high_to_low_text = 'Цена: от высокой к низкой'; sort_price_low_to_high_text = 'Цена: от низкого до высокого';
			clear_all_text = 'Очистить все';
			break;
			case 'se':	refine_by_text = 'Sökningen'; see_all_matching_text = 'Visa alla resultat för';	price_min_from_text = 'från';
			products_title = 'Produkter & kategorier'; 
			pop_searches_title = 'Populära sökningar';
			sort_by_title_text = 'Sortera efter'; sort_match_text = 'Bästa Match'; sort_price_high_to_low_text = 'Pris: Högt till lågt'; sort_price_low_to_high_text = 'Pris: Högt till lågt';
			refine_by_text = 'Filtrera';
			break;
			case 'bg':	refine_by_text = 'Сортиране по'; see_all_matching_text = 'Вижте всички съвпадение на резултатите';	price_min_from_text = 'от';
			products_title = 'Продукти и категории'; 
			pop_searches_title = 'Популярни търсения';
			break;
			case 'cs':	see_all_matching_text = 'Zobrazit všechny odpovídající výsledky';	price_min_from_text = 'od';
			products_title = 'Produkty &amp; Kategorie'; 
			pop_searches_title = 'Populární hledání';
			break;
			case 'da':	see_all_matching_text = 'Se alle matchende resultater';	price_min_from_text = 'fra';
			products_title = 'Produkter &amp; Kategorier'; 
			pop_searches_title = 'populære søgninger';
			sort_by_title_text = 'Sorter efter'; sort_match_text = 'Bedste match'; sort_price_high_to_low_text = 'Pris: høj til lav'; sort_price_low_to_high_text = 'Pris: Lav til høj';
			refine_by_text = 'filtrer efter';
			break;
			case 'fi':	see_all_matching_text = 'Katso kaikki Katso kaikki tulokset';	price_min_from_text = 'alkaen';
			products_title = 'Tuotteet ja tuoteryhmät'; 
			pop_searches_title = 'Suositut haut';
			sort_by_title_text = 'järjestä'; sort_match_text = 'Paras ottelu'; sort_price_high_to_low_text = 'Hinta: Korkeasta alhaiseen'; sort_price_low_to_high_text = 'Hinta: Alhaisesta korkeaan';
			break;
			case 'el':	see_all_matching_text = 'Δείτε όλα τα αποτελέσματα που ταιριάζουν';	price_min_from_text = 'από';
			products_title = 'Προϊόντα και Κατηγορίες'; 
			pop_searches_title = 'δημοφιλείς αναζητήσεις';
			break;
			case 'id':	see_all_matching_text = 'Lihat semua hasil yang cocok';	price_min_from_text = 'dari';
			products_title = 'Produk &amp; Kategori'; 
			pop_searches_title = 'Pencarian populer';
			break;
			case 'tr':  see_all_matching_text = 'Tüm arama sonuçları ';	price_min_from_text = 'itibaren';
			products_title = 'Ürünler ve Kategoriler'; 
			pop_searches_title = 'Popüler aramalar';
			break;
			default:	break;													
		}
	} catch (e)	{}


	function format_product_price_compare_at(data_item, item_currency)	{
		var price_str = '';
		if (data_item.p_c && data_item.p_c != '' && data_item.p_c != 0 && data_item.p_c != 0.00 && data_item.p_c > data_item.p) {
			price_str += ' <span data-currency="' + item_currency + '" data-currency-' + item_currency.toLowerCase() + '="' + data_item.p_c + '" class="isp_compare_at_price money">' + getCurrencyPreSymbol(item_currency) + get_price_format(data_item.p_c, item_currency) + getCurrencyPostSymbol(item_currency) + '</span>';
		}	else	{
			if (data_item.p_min_c && data_item.p_min_c  != '' && data_item.p_min_c != 0 && data_item.p_min_c != 0.00 && data_item.p_min_c > data_item.p_min && data_item.p_min != 0)	{
				price_str += ' <span data-currency="' + item_currency + '" data-currency-' + item_currency.toLowerCase() + '="' + data_item.p_min_c + '" class="isp_compare_at_price money">' + getCurrencyPreSymbol(item_currency) + get_price_format(data_item.p_min_c, item_currency) + getCurrencyPostSymbol(item_currency)  + '</span>';
			}
		}
		return price_str;
	}

	function format_product_price(data_item, item_currency)	{
		var price_str = '';
		if (data_item.p && parseFloat(data_item.p, 10) == 0)	{	return '';	}	
		var p_min = parseFloat(data_item.p_min, 10);
		if (data_item.p_min != 0 ) {		
			switch ( isp_price_range_format )	{
				case 'price_range':		// price range
					price_str += getCurrencyPreSymbol(item_currency) + get_price_format(data_item.p_min, item_currency) + getCurrencyPostSymbol(item_currency);
					price_str += ' - '
					price_str += getCurrencyPreSymbol(item_currency) + get_price_format(data_item.p_max, item_currency) + getCurrencyPostSymbol(item_currency);			
					break;
				case 'max_price':		// show max price
					price_str += getCurrencyPreSymbol(item_currency) + get_price_format(data_item.p_max, item_currency) + getCurrencyPostSymbol(item_currency);
					break;
				default:	// "from ..."
					price_str += price_min_from_text + ' ' + getCurrencyPreSymbol(item_currency) + get_price_format(data_item.p_min, item_currency) + getCurrencyPostSymbol(item_currency);
					break;			
			}			
		} else {		
			price_str += getCurrencyPreSymbol(item_currency) + get_price_format(data_item.p, item_currency) + getCurrencyPostSymbol(item_currency);
		}
		

		return price_str;
	}

	function getCurrencyPreSymbol(currency) {
		var symbol = '';
		
		switch ( currency )	{
			case 'USD': symbol = '$'; 		break;
			case 'CRC': symbol = '₡'; 		break;
			case 'AUD': symbol = '$'; 		break;
			case 'AZN': symbol = 'm.'; 		break;
			case 'NZD': symbol = '$'; 		break;
			case 'MXN': symbol = '$'; 		break;
			case 'CAD': symbol = '$';		break;
			case 'SGD': symbol = 'S$';		break;		
			case 'GBP': symbol = '£';		break;				
			case 'BRL': symbol = 'R$';	 	break;
			case 'ILS': symbol = '₪'; 		break;
			case 'THB': symbol = '฿' ; 		break;			
			
			case 'DKK': symbol = ' DKK';	break;
			case 'NOK': symbol = 'kr ';		break;
			case 'SEK': 		break;
			case 'HKD': symbol = '$'; 	break;
			case 'ZAR': symbol = 'R'; 		break;
			case 'CHF': symbol = 'CHF'; 	break;
			case 'HRK': symbol = 'kn';		break;
			case 'INR': symbol = 'Rs. '; 	break;

			case 'UAH': symbol = ' грн.'; 	break;				
			case 'RUB': symbol = ' руб.'; 	break;
			case 'BYR': symbol = ' руб.'; 	break;
			
			case 'MXN': symbol = '$ '; 		break;
			
			case 'TRY': symbol = ' TL'; 	break; 
			case 'TRL': symbol = ' TL'; 	break; 
			case 'TL':  symbol = ' TL'; 	break;
			
			case 'PLN': symbol = ' zł';		break;
			case 'HUF': symbol = ' Ft';		break;
			case 'MYR': symbol = 'RM ';		break;
			
			case 'BGN': symbol = ' лв.'; 		break;
			case 'EUR': symbol = ' €' ; 		break;				
			case 'RON': symbol = ' lei' ; 		break;			
			case 'VND': symbol = ' ₫';	break;
			
			case 'BDT': symbol = '৳';	break;
			
			default: break;
		}
		
		return symbol;
	}

	function getCurrencyPostSymbol(currency) {
		var symbol = '';
		
		switch ( currency )	{
			case 'MXN': symbol = 'MXN'; 	break;		
			case 'SEK': symbol = ' kr'; 	break;
			default: break;
		}
		
		return symbol;
	}

	function isEmptyDict(obj) {
		for(var prop in obj) {
			if(obj.hasOwnProperty(prop))
				return false;
		}
		return true;
	}

	function smooth_scroll(scroll_top, scroll_top_end)	{
		var cont = document.getElementById('search_res_container');

		if (scroll_top >= (scroll_top_end - 800) )	{	return;	}
		// cont.scrollTop = scroll_top + 10;
		window.scrollBy(0, scroll_top);
		setTimeout(function () {
			smooth_scroll(scroll_top + 10, scroll_top_end);
		}, 1);
	}

	// Sidebars we should avoid in Shopify
	injectCSS( ".side-active .sidebar {display: none;}" );
	injectCSS( " div.row-fluid > div#sidebar {display: none;}" );

	// Parent objects that should span in Shopify for the entire width
	injectCSS( "#page-content.grid-item {width: 100%;}" );
	injectCSS( "body > main > section.rich_content {max-width: 100%;}" );



	try {
		var custom_css 		= localStorage.getItem('custom_css');	// The widget js entered this hopefully...	
		if (custom_css && MOBILE_ENDPOINT == '0')	{	
			injectCSS(custom_css);
		}
	} catch (e) {}


	function injectJS(url)	{
		var s = document.createElement('script');
		s.type = 'text/javascript';					
		s.src = url;
		var x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);
	}

	function currentYPosition() {
		// Firefox, Chrome, Opera, Safari
		if (self.pageYOffset) return self.pageYOffset;
		// Internet Explorer 6 - standards mode
		if (document.documentElement && document.documentElement.scrollTop)
			return document.documentElement.scrollTop;
		// Internet Explorer 6, 7 and 8
		if (document.body.scrollTop) return document.body.scrollTop;
		return 0;
	}

	function toggleDropdown(active_dropdown_num, show)	{	
		var jq = $jquery_isp('#facet_drop_container_' + active_dropdown_num);
		if (show)	{
			jq.toggleClass('open');
		}	else	{
			jq.removeClass('open');
		}
		
		try {		
			event.preventDefault();
			event.stopImmediatePropagation();        
		} catch (e)	{}	
		return false;
	}

	function toggleDropdownSort(show)  {   
		var jq = $jquery_isp('#sorting_drop_container');
		if (show)   {
			jq.addClass('open');
		}   else    {
			jq.removeClass('open');
		}
		
		try {       
			event.preventDefault();
			event.stopImmediatePropagation();        
		} catch (e) {}  
		return false;
	}


	function getStyle(el,styleProp) {
	  var camelize = function (str) {
		return str.replace(/\-(\w)/g, function(str, letter){
		  return letter.toUpperCase();
		});
	  };

	  if (el.currentStyle) {
		return el.currentStyle[camelize(styleProp)];
	  } else if (document.defaultView && document.defaultView.getComputedStyle) {
		return document.defaultView.getComputedStyle(el,null)
								   .getPropertyValue(styleProp);
	  } else {
		return el.style[camelize(styleProp)]; 
	  }
	}


	var isp_price_range_format = 'from_min';	// price_range, from_min, max_price
	try {
		var isp_price_range_format = localStorage.getItem('isp_price_range_format');		
	} catch (e) {}


	function handleSortingDisplay(data){
		if (isp_results_page_enable_sorting){
			var default_sort_value = 'relevency';
			$jquery_isp('ul#search_res_sorting_menu').css('display', '');
			$jquery_isp('ul#sorting_drop_list li a').each(function(){
				if ($jquery_isp(this).hasClass('selected_facet_value')){
					$jquery_isp(this).removeClass('selected_facet_value');
				}
			});
			
			if ('sort_by' in data && data.sort_by != ''){
				var new_sorting_value = $jquery_isp('ul#sorting_drop_list li a[sort_value="' + data.sort_by + '"]').html();
				$jquery_isp('li#sorting_drop_container a span#sorting_chosen_name').html(new_sorting_value);    // changing chosen sort by name
				
				// marking selected class
				$jquery_isp('ul#sorting_drop_list li a[sort_value="' + data.sort_by + '"]').toggleClass('selected_facet_value');
				global_last_sort_by_value = data.sort_by;
			} else {    // default value
				var new_sorting_value = $jquery_isp('ul#sorting_drop_list li a[sort_value="' + default_sort_value + '"]').html();
				$jquery_isp('li#sorting_drop_container a span#sorting_chosen_name').html(new_sorting_value);    // changing chosen sort by name
				
				$jquery_isp('ul#sorting_drop_list li a[sort_value="' + default_sort_value + '"]').toggleClass('selected_facet_value');
				global_last_sort_by_value = '';
			}
		} else {
			$jquery_isp('ul#search_res_sorting_menu').css('display', 'none');
			global_last_sort_by_value = '';
		}
	}

	function clearSortingDisplay(){
		$jquery_isp('ul#search_res_sorting_menu').css('display', 'none');
		global_last_sort_by_value = '';
	}


	function handleSortingChoice(event, element){
		performSortedSearch(element);
		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();
	}

	function performSortedSearch(element) {
		var sort_value = element.getAttribute('sort_value');
		if (sort_value == null) {
			sort_value = '';
		}
		global_last_sort_by_value = sort_value;
		do_full_text_search( latest_full_text_search, 1, 0, false );  
	}

	function render_yotpo_stars(data, product_identifier)	{
		if ( product_identifier != 0 )	{
			if (data && data.response && data.response.bottomline && data.response.bottomline.total_reviews > 0)	{
				var ids = '#isp_yotpo_' + product_identifier + ', #isp_yotpo_back_' + product_identifier;
				if ( $jquery_isp(ids).html() == '' )	{
					// Only add these reviews if the hosting div is empty
					$jquery_isp(ids).raty({ readOnly: true, score: data.response.bottomline.average_score });
					$jquery_isp(ids).attr("title", "Average Score: " + data.response.bottomline.average_score + " | Total reviews: " + data.response.bottomline.total_reviews);
				}
			}
		}
	}

	function get_price_format(price, currency)	{
		switch (currency)	{
			/*case 'BRL':
			case 'JMD':
			case 'DKK':
			case 'BGN':
			case 'EUR':
				return euro_pricing(price);	break;*/
			default:
				try {
					return isp_to_money(price, 2, '.', ',');
				} catch (e)	{
					return price;	
				}
				break;	
		}
	}

	function isp_to_money(n, decimals, decimal_sep, thousands_sep)	{ 
	   var c = isNaN(decimals) ? 2 : Math.abs(decimals), //if decimal is zero we must take it, it means user does not want to show any decimal
	   d = decimal_sep || '.', //if no decimal separator is passed we use the dot as default decimal separator (we MUST use a decimal separator)

	   /*
	   according to [http://stackoverflow.com/questions/411352/how-best-to-determine-if-an-argument-is-not-sent-to-the-javascript-function]
	   the fastest way to check for not defined parameter is to use typeof value === 'undefined' 
	   rather than doing value === undefined.
	   */   
	   t = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep, //if you don't want to use a thousands separator you can pass empty string as thousands_sep value

	   sign = (n < 0) ? '-' : '',

	   //extracting the absolute value of the integer part of the number and converting to string
	   i = parseInt(n = Math.abs(n).toFixed(c)) + '', 

	   j = ((j = i.length) > 3) ? j % 3 : 0; 
	   return sign + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : ''); 
	}


	function euro_pricing(number)	{
		var numberStr = parseFloat(number).toFixed(2).toString();
		var numFormatDec = numberStr.slice(-2); /*decimal 00*/
		numberStr = numberStr.substring(0, numberStr.length-3); /*cut last 3 strings*/
		var numFormat = new Array;
		while (numberStr.length > 3) {
			numFormat.unshift(numberStr.slice(-3));
			numberStr = numberStr.substring(0, numberStr.length-3);
		}
		numFormat.unshift(numberStr);
		return numFormat.join('.')+','+numFormatDec; /*format 000.000.000,00 */
	}

	var global_run_already=false;	//	weird situation where the clearInterval is not being dismissed

	function _isp_is_serp_ready() {
		var obj = document.getElementById('search_res_container');
		return (typeof obj != 'undefined' && obj != null);
	}

	if (_isp_is_serp_ready()) {
		global_run_already = true;					
		isp_onload();	
	}
	else {
		_isp_interval_was_needed = true;
		var interval_event = setInterval( function() {
			if (_isp_is_serp_ready() && global_run_already ==false)	{
				global_run_already = true;					
				isp_onload();
				clearInterval(interval_event);	// clear the interval checker...
			}
		 }, 55);
	}	

} // end of __isp_serp_injected